const signUp = {
  SIGN_UP_TO_JOIN_US: "Sign Up to Join Us",
  USER_PROFILE: "User Profile",
  LOGIN_CREDENTIALS: "Login Credentials",
  CONFIRM_PASSWORD: "Confirm Password",
  PLEASE_ENTER_YOUR_USERNAME: "Please enter your username",
  PLEASE_ENTER_YOUR_PASSWORD: "Please enter your password",
  PLEASE_CONFIRM_YOUR_PASSWORD: "Please confirm your password",
  PLEASE_ENTER_YOUR_EMAIL: "Please enter your email",
  PLEASE_ENTER_YOUR_PHONE: "Please enter your phone",
  EG_PROFESSOR_OF_TRADITIONAL_CHINESE_MEDICINE:
    "Eg. Professional of Traditional Chinese Medicine",
  PLEASE_BRIEFLY_INTRODUCE_YOURSELF: "Please briefly introduce yourself",
  TRADITIONAL_CHINESE_MEDICINE_IS_A_DISCIPLINE_THAT_UTILIZES_NATURAL_PRINCIPLES_COMBINED_WITH_VARIOUS_PHYSIOLOGICAL_AND_PATHOLOGICAL_CHANGES_IN_THE_BODY:
    "EG: Traditional Chinese Medicine is a discipline that uses natural principles combined with various physiological and pathological changes in the body.",
  HERBAL_MEDICINE: "Herbal Medicine",
  SIGN_UP: "Sign Up",
  SIGN_UP_AS_PRACTITIONER: "Sign Up as Practitioner",
};

const navigation = {
  PRACTITIONER: "Practitioner",
  PRACTITIONER_PORTAL: "Practitioner Portal",
  HOME: "Home",
  ABOUT_US: "About Us",
  PARTNERS: "Partners",
  MEMBER_SERVICE: "Member Service",
  CPD_TRAINING: "CPD Activity",
  TRAINING_AND_COURSES: "Training and Courses",
  EVENT: "Event",
  NEWS: "Latest News",
  BECOMING_MEMBER: "Become a Member",
  LOGIN_SIGNUP: "Login/Sign Up",
  ONLINE_PAYMENT: "Online Payment",
  DOWNLOAD_CENTER: "Downloads",
  AGREE_TO_USE_VAI_CLINIC_TEXT:
    "By Signing in, you agree to use Healthnex Clinic in accordance with the ",
  SIGN_IN: "Sign In",
  SIGN_OUT: "Sign Out",
  USERNAME: "Username",
  PASSWORD: "Password",
  FORGET_PASSWORD: "Forgot Password?",
  AND: " and ",
  PLEASE_ENTER_YOUR_USERNAME: "Please enter your username",
  PLEASE_ENTER_YOUR_PASSWORD: "Please enter your password",
  CLINIC: "Clinic",
  PRACTITIONER_PROFILE: "Practitioner Website",
  CONTACT_US: "Contact Us",
  GO_BACK: "Go Back",
  PREVIOUS_FEATURE: "Previous Feature",
  NEXT_FEATURE: "Next Feature",
  STILL_HAVE_QUESTIONS: "Still have questions?",
  FAQ_HELP_DESCRIPTION: "Our team is here to help.",
  FAQ_SUPPORTING_LINE: "Quick answers to the questions we hear most.",
  ADD_PATIENT: "Add Patient",
  SELECT_CLINIC_TO_WORK: "Select Clinic to Work",
  SELECT_CLINIC: "Select Clinic",
  PRESCRIPTION_MEDICAL_HISTORY: "Prescription & Medical History",
};

const prescription = {
  CLEAR_SEARCH: "Clear",
  PRESCRIPTION: "Medical History",
  PATIENT_PRESCRIPTION: "Patient's Medical History",
  DOCTOR_PRESCRIPTION: "Doctor Prescription",
  NO_PRESCRIPTION_FOUND: "No Prescription Found",
  NO_PREVIOUS_HISTORY: "No Previous History",
  PRESCRIPTION_NOT_FOUND: "Prescription Not Found",
  "EDIT_NOW_HISTORY_#X": "Editing Medical History #{{X}} Now",
  EDITING_NOW: "Editing Now",
  NO_ENGLISH_ENTRY: "No English Entry",
  NO_CHINESE_ENTRY: "No Chinese Entry",
  ENGLISH_CONTENT: "English Content",
  CHINESE_CONTENT: "Chinese Content",
  CASE_ID: "Case ID",
  DATE: "Date",
  CREATED_BY: "Created By",
  PAYMENT_STATUS: "Payment Status",
  ACTION: "Action",
  NOT_PAID: "Not Paid",
  PAID: "Paid",
  CARD_ONLINE: "Card Online",
  CARD_OFFLINE: "Card Offline",
  CASH: "Cash",
  FILTER_BY_DATE: "Filter By Date",
  SELECT_DEFAULT_DATE_RANGE: "Select Default Date Range",
  SELECT_CUSTOM_DATE_RANGE: "Select Custom Date Range",
  LAST_ONE_YEAR: "Last One Year",
  LAST_ONE_MONTH: "Last One Month",
  LAST_THREE_MONTHS: "Last Three Months",
  ROWS_PER_PAGE: "Rows Per Page",
  MORE_INFORMATION: "More Information",
  AGE: "Age",
  PRESCRIPTION_FORM: "Prescription Form",
  CREATE_CASE: "Create Case",
  SELECT_OPTIONS: "Select Options",
  CLICK_TO_RECORD: "Click to Record",
  TRANSLATE_TO_X: "Translate to {{X}}",
  COMPLAINTS_SYMPTOMS: "Complaints & Symptoms",
  PAST_DISEASE: "Past Disease",
  FAMILY_DISEASE_HISTORY: "Family Disease History",
  ALLERGY: "Allergy",
  ALLERGEN: "Allergen",
  CURRENT_MEDICINE_TAKEN: "Current Medicine Taken",
  SIGNS_DIAGNOSIS: "Signs and Diagnosis",
  ATTACHMENT: "Attachment",
  REMARKS: "Remarks",
  CLICK_DRAG_TO_UPLOAD: "Click or Drag to Upload",
  NO_ATTACHMENT_FOUND: "No Attachment Found",
  TREATMENT_PLAN: "Treatment Plan",
  PATIENT_ADVICES: "Patient Advices",
  PROCEED_TO_PAYMENT: "Proceed to Payment",
  PROCEED_TO_TREATMENT: "Proceed to Treatment",
  MEDICINE: "Medicine",
  PRESCRIBE_MEDICATION_TO_THE_PATIENT: "Prescribe Medicine to the Patient",
  PRESCRIBE_ACUPUNCTURE_TO_THE_PATIENT:
    "Provide Acupuncture Treatment to the Patient",
  PRESCRIBE_MASSAGE_TO_THE_PATIENT: "Provide Massage Treatment to the Patient",
  PRESCRIBE_REMEDIAL_MASSAGE_TO_THE_PATIENT:
    "Provide Remedial Massage Treatment to the Patient",
  SELECT: "Select",
  MODALITY: "Modality",
  MEDICINE_TREATMENT_NAME: "Medicine Treatment Name",
  PREVIOUS_STEP: "Previous Step",
  PATIENT_HERB_HISTORY: "Patient Herb History",
  APPLY: "Apply",
  HERB: "Herb",
  RAW: "Raw (g)",
  GRAN: "Gran (g)",
  TOTAL: "Total",
  FORMULA: "Formula",
  CLASSICAL: "Herb Formula",
  SINGLE_HERB: "Single Herb",
  TYPE: "Type",
  SELECT_HERBS: "Select Herbs",
  SEARCH_CLASSICAL_FORMULA: "Search Herb Formula",
  PLEASE_SEARCH_BY_NAME: "Please search by name",
  CANCEL_SEARCH: "Cancel Search",
  ADD_ALL_HERBS_IN_FORMULA: "Add All Herbs in Formula",
  X_HERBS_INCLUDED: "{{X}} Herbs Included",
  FILL_IN_THE_DOSAGE: "Fill in the Dosage",
  HERBS_ADDED: "Herbs Added",
  PLS_SELECT_HERB_FROM_HISTORY_OR_FORMULA:
    "Please select herb from history or formula",
  GRAMS_DAILY: "Grans Daily",
  DAYS: "Days",
  TOTAL_GRANS: "Total Grans",
  DOSAGE_INSTRUCTION: "Dosage Instruction",
  DOSAGE: "Dosage",
  NO_OF_REPEATS: "No. of Repeats",
  TO_BE_DISPENSED_AFTER: "To be dispensed after",
  WEEK: "Week",
  RAW_HERBS: "Raw Herbs",
  HERBS_EXTRACT: "Herbs Extract",
  HERBAL_MEDICATION: "Herbal Medicine",
  EXTERNAL: "External",
  HERB_BOIL_GUIDE: "Herb Boil Guide",
  SECOND_BOIL_REQUIRED: "Second Boil Required",
  FIRST_BOILS: "First Boils",
  NO_CUP_WATER: "No. of Cup Water",
  BOIL_TIME: "Boil Time",
  NO_CUPS_REMAINS: "No of Cups Remains",
  MIN_BOIL_TIME: "Minimum Boil Time (Mins)",
  PLEASE_ENTER_NUMBER: "Please enter number",
  SELECT_POINT: "Select Point",
  X_HISTORY: "{{X}} History",
  POINT: "Point",
  X_GROUP: "{{X}} Group",
  POINT_GROUPS: "Point Groups",
  ORDER: "Order",
  SINGLE_POINT: "Single Point",
  REVIEW_THE_POINTS: "Review the Points",
  PLS_SELECT_POINT_FROM_HISTORY_OR_GROUP:
    "Please select point from history or group",
  DROP_HERE: "Drop Here",
  X_INSTRUCTION: "{{X}} Instruction",
  DURATION: "Duration",
  PLS_ENTER_THE_DURATION: "Please enter the duration",
  PRECAUTION: "Precaution",
  PLS_ENTER_THE_PRECAUTION: "Please enter the precaution",
  POINTS_ADDED: "Points Added",
  PAYMENT: "Payment",
  FILL_IN_THE_PAYMENT_DETAILS: "Fill in the Payment Details",
  SUBTOTAL: "Subtotal",
  OTHER_FEE: "Other Fee",
  DIAGNOSIS_FEE: "Diagnosis Fee",
  FEE: "Fee",
  TOTAL_AMOUNTS: "Total Amounts",
  ADD_FEE: "Add Fee",
  FEE_LABEL: "Fee Label",
  PLEASE_ENTER_LABEL: "Please enter label",
  FEE_AMOUNT: "Fee Amount",
  PLEASE_ENTER_AMOUNT: "Please enter amount",
  MEDICAL_REBATE: "Medical Rebate",
  MEDICAL_FUNDS_OF_PATIENT: "Use Medical Funds of Patient",
  REBATE_AMOUNT: "Rebate Amount",
  ANY_DISCOUNT: "Any Discount",
  PENDING_PAYMENT_AMOUNT: "Pending Payment Amount",
  PAYMENT_METHOD: "Payment Method",
  DISCOUNT_AMOUNT: "Discount Amount",
  FINISH_PAYMENT: "Finish Payment",
  PLEASE_ENTER_YOUR_CARD_DETAILS_BELOW_TO_COMPLETE_YOUR_PURCHASE:
    "Please enter your card details below to complete your purchase",
  PAYMENT_FAILED_PLEASE_TRY_AGAIN: "Payment failed. Please try again",
  X_TRIES_LEFT: "{{X}} tries left",
  TOTAL_AMOUNT_CANNOT_BE_NEGATIVE: "Total amount cannot be negative",
  PAY_NOW: "Pay Now",
  YOUR_PAYMENT_HAS_BEEN_SUCCESSFULLY_PROCESSED:
    "Your payment has been successfully processed",
  SYSTEM_REDICTING: "System is redicting...",
  SURCHARGE_WILL_BE_INCLUDED: "Surcharge Included",
  PROCESSING_PAYMENT: "Processing Payment",
  LAST_MODIFIED_AT: "Last Modified At",
  PAY: "Pay",
  NEXT: "Next",
  PRINT_RECEIPT: "Print Receipt",
  GENERATING: "Generating Receipt",
  NO_MEDICAL_HISTORY_FOUND: "No Medical History Filled Out",
  NO_TREATMENTS_INCLUDED: "No Treatments Included",
  TREATMENT: "Treatment",
  VIEW_X_INSTRUCTION: "View {{X}} Instruction",
  X_SURCHARGE_AMOUNT: "{{X}} Surcharge Amount",
  DISCOUNT: "Discount",
  COLLAPSE_ALL: "Collapse All",
  EXPAND_ALL: "Expand All",
  VIEW_DOSAGE_INSTRUCTION: "View Dosage Instruction",
  NO_TREATMENTS_INCLUDED: "No Treatments Included",
  FINISH: "Finish",
  X_OPTIONS: "{{X}} Options",
  FULL_CONTENT_MODE: "Full Content Mode",
  HAS_BEEN_ADDED: " has been added",
  ALL_HERBS_IN_FORMULA_HAS_ADDED: "All herbs in formula has been added",
  CLASSICAL_FORMULA: "Herb Formula",
  PLS_ENTER_NUMBER: "Please enter number",
  SEARCH_CLASSICAL_FORMULA_BY_NAME: "Search Formula by name",
  SEARCH_HERB_BY_NAME: "Search Herb by name",
  REMOVE_TREATMENT: "Remove Treatment",
  ARE_YOU_SURE_TO_REMOVE: "Are you sure to remove",
  SECOND_BOILS: "Second Boils",
  MIN_BOILING: "Minutes of Boiling",
  X_POINTS_INCLUDED: "{{X}} Points Included",
  ADD_ALL_POINTS_IN_FORMULA: "Add all points in group",
  SEARCH_POINT_GROUPS_BY_NAME: "Search Point Groups by name",
  SEARCH_POINT_BY_NAME: "Search Point by name",
  ALL_POINTS_IN_FORMULA_HAS_ADDED: "All points in group has been added",
  THIS_TREATMENT_HAS_NO_PRICE_OR_PRICE_ZERO:
    "This treatment has no price or price is zero",
  PAYMENT_CHANNEL_EXPIRED_PLS_RELOAD_PAGE:
    "Payment channel has expired, please reload the page",
  ENTER_FEE_AMOUNT: "Enter Fee Amount",
  NO_TREATMENT_INCLUDED_IN_THIS_PRESCRIPTION:
    "No Treatment included in this Prescription",
  PLEASE_SELECT_TREATMENT_TO_PROCEED:
    "Please select a modality to proceed treatment",
  ADD_TREATMENT: "Add Treatment",
  HAS_REMOVED: " has been removed",
  ATTACHMENT_UPLOADED: "Attachment uploaded",
  REMOVE_ATTACHMENT: "Remove Attachment",
  ARE_YOU_SURE_TO_REMOVE_THIS_FILE: "Are you sure to remove this file?",
  ATTACHMENT_REMOVED: "Attachment removed",
  LAST_SIX_MONTHS: "Last 6 Months",
  INPUT_TOTAL_COST_HERE: "Input treatment cost here",
  EDIT_PATIENT_INFO: "Edit Patient Info",
  ARE_YOU_SURE_TO_CLEAR_ALL_CONTENT_IN_THIS_FIELD:
    "Are you sure to clear all content written below?",
  CLEAR_CONFIRM: "Clear Confirm",
  DUPLICATE_MEDICAL_HISTORY: "Duplicate Record",
  ARE_YOU_SURE_TO_DUPLICATE_THIS_MEDICAL_HISTORY:
    "You are tend to duplicate the selected medical history",
  YOU_WILL_GET_A_NEW_MEDICAL_HISTORY_WITH_PREFILLED_DATA_FROM_LAST_RECORD:
    "You will get a new medical history with prefilled data SAME as your selected medical history",
  ARE_YOU_SURE_TO_DELETE_MEDICAL_RECORD:
    "Are you sure to delete this medical record",
  PATIENT_HISTORY_COPIED: "Patient history copied",
  DELETE_SUCCESS: "Delete Success",
  ADD_ASSISTANT_EXAMINATION: "Add auxiliary examination",
  ADD_NOW: "Add now",
  RESULT_PREVIEW: "Preview",
  AUXILIARY_TEST: "Auxiliary test",
  TEST_NAME: "Test name",
  TEST_DATE: "Test date",
  ATTACHMENTS: "Attachments",
  SELECT_PHOTO_PDF: "Select photo/PDF",
  EXAMINATION: "Examination",
  INSPECTION: "Inspection (TCM visual diagnosis)",
  TONGUE_PHOTO: "Tongue photo",
  FACIAL_PHOTO: "Facial photo",
  INQUIRY: "Inquiry (TCM questioning)",
  PULSE: "Pulse diagnosis",
  LISTEN_SMELL: "Listening & smelling diagnosis",
  BODY_TEMP: "Body temperature",
  BLOOD_PRESSURE: "Blood pressure",
  PULSE_RATE: "Pulse rate",
  BREATH_RATE: "Breathing rate",
  PERSONAL_OTHER: "Personal habits & others",
  ANY_ALLERGY: "Any allergy",
  ALLERGY_DRUGS: "Drug allergy",
  ALLERGY_TRIGGERS: "Allergy triggers",
  STD: "STD history",
  PROMISCUITY: "Promiscuity",
  SMOKING: "Smoking",
  ALCOHOL_ABUSE: "Alcohol abuse",
  ADD_HISTORY: "Add past medical history",
  NO_DISEASES: "No past medical history",
  FAMILY_DISEASES: "Family history of disease",
  SYMPTOMS: "Symptoms",
  NO_SYMPTOMS_ADDED: "No symptoms added",
  MAIN_SYMPTOM: "Main symptom",
  ONSITE_TIME: "Onset time",
  TIME_UNIT: "Time unit",
  RECURRENCE_TIME: "Recurrence time",
  EXACERBATION_TIME: "Exacerbation time",
  FREQUENCY_OF_OCCURRENCE: "Frequency of occurrence",
  FREQUENCY: "Frequency",
  ADD_MAIN_SYMPTOMS: "Add main symptoms",
  PREDISPOSITION: "Predisposing factor",
  ASSOCIATED_SYMPTOMS: "Associated symptoms",
  ARE_YOU_SURE_TO_DELETE_THIS_SYMPTOM: "Are you sure to delete this symptom?",
  DURATION: "Duration",
  ADD_ASSISTANT_EXAMINATION: "Add auxiliary examination",
  OTHERS: "Others",
  PROCEED_TO_DIAGNOSIS: "Proceed to Diagnosis",
  UPDATE_SUCCESS: "Save Success",
  PREVIOUS_TREATMENT: "Previous Treatment",
  ASSISTANT_EXAMINATION: "Assistant Examination",
  CLICK_TO_ADD: "Click to search and add",
  CLICK_TO_SELECT: "Click to search and select",
  PREVIOUS_HISTORY: "Previous medical history",
  ADD_EVALUATION: "Add evaluation",
  TCM_ICD_CODE: "TCM ICD code",
  DETERMINATION_TCM: "TCM diagnosis name",
  SYNDROME: "TCM syndrome name",
  EVALUATION: "Diagnosis",
  DISCIPLINE_TREATMENT_OPTIONS: "Treatment principles and methods",
  ARE_YOU_SURE_TO_DELETE_THIS_RECORD: "Are you sure to delete this record?",
  BPM: "Per Min",
  SYSTOLIC: "Systolic",
  DIASTOLIC: "Diastolic",
  ADD_NEW_INSURANCE: "Add Medical Fund",
  PLZ_INPUT_INSURANCE_NO: "Please input insurance number",
  PLZ_INPUT_COMPANY_NAME: "Please input insurance company name",
  RESULT: "Result",
};

const search = {
  SEARCH: "Search",
  SEARCH_PLACEHOLDER: "Search",
  SEARCH_RESULT: "Search Result",
  NO_SEARCH_RESULT: "No Search Result",
  SEARCHING: "Searching",
  SEARCH_PATIENT: "Search Patient by name/email/phone",
  SEARCH_FOR_PATIENT_IN_TOP_SEARCH_BAR_OR_NEW_PATIENT_HERE:
    "Search for a patient below by their patient name, or add a new patient using the button on the left.",
  SEARCH_PATIENT_BY_NAME: "Search patient by name/email/phone",
  NO_PATIENT_FOUND: "No patient found",
  SEARCHING_PATIENT: "Searching for patient",
};

const info = {
  DOB: "Date of Birth",
  DATE_OF_BIRTH: "Date of Birth",
  SELECT_PATIENT: "Select Patient",
  X_PRESCRIPTION_INFO: "{{X}}'s Prescription",
  VIEW_DETAILS: "View Details",
  "MEDICAL_HISTORY_#X": "Medical History #{{X}}",
  LAST_MODIFIED_BY_X_AT_Y: "Last modified by {{X}} at {{Y}}",
  NEW_MEDICAL_HISTORY: "New Medical History",
  NOT_SAVED_YET: "Not Saved Yet",
  SAVE_HISTORY: "Save History",
  PATIENT_INFO: "Patient Info",
  PATIENT_ID: "Patient ID",
  GENDER: "Gender",
  MALE: "Male",
  FEMALE: "Female",
  MEDICAL_HISTORY: "Medical History",
  APPOINTMENT: "Appointment History",
  NO_HISTORY_FOUND: "No History Found",
  DESCRIPTION: "Personal Description",
  COMPLAINTS_SYMPTOMS: "Complaints/Symptoms",
  DIAGNOSIS: "Diagnosis",
  TREATMENT: "Treatment",
  ENGLISH_CONTENT_GOES_HERE: "English content goes here",
  CN_CONTENT_GOES_HERE: "Chinese content goes here",
  EDITING: "Editing",
  SIGNS_DIAGNOSIS: "Signs and Diagnosis",
  TREATMENT_STRATEGIES: "Treatment Strategies",
  ACUPUNCTURE_POINTS_DURATION_METHODS:
    "Acupuncture Points, Duration and Methods",
  ALLERGY: "ALLERGY",
  THERAPEUTICAL_MASSAGE: "Therapeutical Massage",
  GUA_SHA: "Gua Sha",
  OTHER: "Other",
  REMARKS: "Remarks",
  TRANSLATE_FROM_X: "Translated from {{X}}",
  TRANSLATE_TO_X: "Translate to {{X}}",
  TRANSLATE: "Translate",
  CHINESE: "Chinese",
  ENGLISH: "English",
  TRANSLATION_CONFIRM: "Translation Confirm",
  TRANSLATED_CONTENT_WILL_BE_APPLIED_OVERWRITE_UR_EXISTING_CONTENT:
    "Translated content will be applied and overwrite your existing content.",
  TRANSLATE_FROM_X_TO_Y: "Translated from {{X}} to {{Y}}",
  ARE_YOU_SURE_TO_TRANSLATE: "Are you sure to translate",
  INFO_FILLED: "Information saved",
  NO_DATA_FOUND: "No Data Found",
  FULL_CONTENT_X: "Full Medical Record: {{X}}",
  "UPDATE_HISTORY_#X": "Update Medical History #{{X}}",
  EDIT_DESCRIPTION: "Edit Personal Description",
  EDIT_PATIENT: "Edit Patient",
  BASIC_INFO: "Basic Info",
  FIRST_NAME: "First Name",
  LAST_NAME: "Last Name",
  CONTACT_DETAIL: "Contact Detail",
  RESIDENTIAL_ADDRESS: "Residential Address",
  EMERGENCY_CONTACT_DETAIL: "Emergency Contact Detail",
  RELATIONSHIP: "Relationship",
  PATIENT_DISCLOSE: "Patient Disclose",
  GUARDIAN_NAME: "Guardian Name",
  GUARDIAN: "Guardian",
  GUARDIAN_CONTACT_NUMBER: "Guardian Contact Number",
  GUARDIAN_MOBILE: "Guardian Mobile",
  REFERRED_BY: "Referred By",
  NO_INSURANCE: "No Medical Fund",
  EMERGENCY_CONTACT_PERSON: "Emergency Contact Person",
  EMERGENCY_CONTACT_NUMBER: "Emergency Contact Number",
  INSURANCE_INFO: "Medical Fund Info",
  MORE_DETAILS: "More Details",
  INSURANCE_X: "Medical Fund {{X}}",
  COMPANY_NAME: "Company Name",
  INSURANCE_NO: "Insurance No",
  EXPIRY_DATE: "Expiry Date",
  ADD_INSURANCE: "Add Medical Fund",
  CANCEL: "Cancel",
  CONFIRM: "Confirm",
  SELECT_TEMPLATE: "Select Website Template",
  ADD_TEMPLATE: "Add Template",
  EDIT_TEMPLATE: "Edit Mode",
  PUBLISH_WEBSITE: "Publish Website",
  VIEW_PUBLISHED_WEB: "Preview Published Website",
  TEMPLATE: "Template",
  INSURANCE: "Medical Fund",
  EXPIRED_IN: "Expired in",
  EXIT_EDIT: "Exit Edit",
  X_VERSION: "{{X}} Version",
  MAKE_APPOINTMENT: "Make Appointment",
  AI_TRANSLATE: "AI Translate",
  EDIT_TITLE: "Edit Title",
  EDIT_NAME: "Edit Name",
  EDIT_INTRODUCTION: "Edit Brief Description",
  ADD_SKILL: "Add Top Skill",
  SKILL: "Skill",
  AI_ENQUIRY: "AI Inquiry",
  EDIT_AVATAR: "Edit Profile Image",
  ADD_AVATAR: "Add Profile Image",
  EDIT_CLINIC: "Edit Clinic",
  MY_STRENGTHS: "My Strengths",
  STANDARD_TREATMENT: "Treatment Features",
  ACADEMIC: "Academic",
  PATIENT_REVIEW: "Patient Review",
  CLINIC_INFO: "Clinic Info",
  EDIT_STRENGTHS: "Edit Strengths",
  EDIT_TREATMENT: "Edit Treatment",
  DR_X_ARTICLE: "{{X}}'s Article",
  COURSES: "Courses",
  ARTICLES: "Articles",
  EDIT_COURSE: "Edit Course",
  UPLOAD_REVIEW_BG: "Upload Review Background Image",
  EDIT_REVIEW: "Edit Patient Review",
  PATIENT: "Patient",
  TITLE: "Title",
  SAVE_SUCCESS: "Save Success",
  CLINIC_NAME: "Clinic Name",
  PIN_TO_DISPLAY: "Pin to Display",
  DELETE: "Delete",
  SUBURB: "Suburb",
  POSTCODE: "Postcode",
  STATE: "State",
  ADD: "Add",
  MOVE_DOWN: "Move Down",
  MOVE_UP: "Move Up",
  SPECIALITY: "Speciality",
  PUBLISHED: "Published",
  HIDDEN: "Hidden",
  READ: "Read",
  ADD_ARTICLE: "Add Article",
  SAVE: "Save",
  PUBLISH: "Publish",
  RE_UPLOAD_BG: "Re-Upload Background Image",
  PATIENT_NAME: "Patient Name",
  PATIENT_DESCRIPTION: "Patient Description",
  REVIEW: "Review",
  REUPLOAD_PROFILE_IMAGE: "Re-Upload Profile Image",
  COURSE: "Course",
  COURSE_TITLE: "Course Title",
  START_DATE: "Start Date",
  START_TIME: "Start Time",
  DURATION: "Duration",
  COURSE_TYPE: "Course Type",
  OFFLINE_COURSE: "Offline Course",
  ONLINE_COURSE: "Online Course",
  MEETING_URL: "Course Link",
  LOCATION: "Location",
  STRENGTH: "Strength",
  EXIT_PREVIEW: "Exit Preview",
  MY_PROFILE: "My Profile",
  PURE_HARMONY: "Clean and Professional Template",
  HERB_ESSENCE: "Fresh and Sophisticated Template",
  IM_WORKED_AT: " I'm working at",
  START_WORKING: "Start Working",
  TOOLBAR: "Toolbar",
  COLLAPSE_TOOLBAR: "Collapse Toolbar",
  EDIT_URL: "Edit URL",
  SLUG: "Slug",
  EDIT_SLUG: "Edit Profile Page URL",
  PUBLISH_CONFIRM: "Publish Confirm",
  UNPUBLISH_CONFIRM: "Unpublish Confirm",
  ARE_YOU_SURE_TO_X_WEBSITE: "Are you sure to {{X}} website?",
  WEBSITE_WILL_BE_PUBLISHED_AND_VISIBLE_TO_PUBLIC_VIA_BELOW_LINK:
    "Website will be published and visible to public via below link",
  WEBSITE_WILL_BE_UNPUBLISHED_AND_HIDDEN_FROM_PUBLIC:
    "Website will be unpublished and hidden from public",
  U_CAN_STILL_PUBLISH_THE_WSBSITE_LATE_IF_U_WISH:
    "You can still publish the website later if you wish",
  PUBLISH_S: "publish",
  UNPUBLISH_S: "unpublish",
  UNPUBLISH_WEBSITE: "Unpublish Website",
  UNPUBLISHED: "Unpublished",
  SWITCH_YOUR_TEMPLATE_PUBLISHED: "Select a new webpage template to publish.",
  CLOSE_EDITOR: "Close Editor",
  CLOSE: "Close",
  REMOVE_SUCCESS: "Remove Success",
  VIEW_ALL_X_CLINICS: "View All {{X}} Clinics",
  CONTINUE: "Continue",
  ONLY_WORKING_WEEKDAY: "Only Working Weekday",
  WORKING_TIME: "Working Time",
  WORKING_IN_WHOLE_WEEK: "Working all Week",
  MONDAY: "Mon",
  TUESDAY: "Tue",
  WEDNESDAY: "Wed",
  THURSDAY: "Thu",
  FRIDAY: "Fri",
  SATURDAY: "Sat",
  SUNDAY: "Sun",
  WORKING_TODAY: "Set as Working Day",
  END_TIME: "End Time",
  APPLY_WORKING_TIME_TO_ALL_DAYS: "Apply Working Hours to All Days",
  ONLY_WORK_IN_WEEKDAYS: "Only Work in Weekdays",
  WORK_IN_WHOLE_WEEK: "Work all Week",
  CURRENT_WORKING_TIME_APPLIED_TO_ALL_DAYS:
    "Current working time has been applied to all days",
  DR_X_COURSE: "{{X}}'s Courses",
  DELETE_ARTICLE: "Delete Article",
  ARE_YOU_SURE_TO_DELETE_ARTICLE: "Are you sure to delete this Article?",
  THIS_ACTION_CANNOT_BE_UNDONE: "This action cannot be undone",
  SAVE_ARTICLE: "Save Article",
  SAVE_ARTICLE_AND_PUBLISH: "Save Article and Publish",
  PUBISH_ARTICLE: "Publish Article",
  UNPUBLISH_ARTICLE: "Unpublish Article",
  PUBLISH_ARTICLE: "Publish Article",
  ARE_YOU_SURE_TO_X_ARTICLE: "Are you sure not to {{X}} article?",
  VISITORS_WILL_NOT_BE_ABLE_TO_VIEW_THIS_ARTICLE:
    "Visitors will not be able to view this article",
  VISITORS_WILL_BE_ABLE_TO_VIEW_THIS_ARTICLE:
    "Visitors will be able to view this article",
  UNPUBLISH: "Unpublish",
  REMOVE_BG_IMAGE: "Remove Background Image",
  ARE_YOU_SURE_TO_REMOVE_BG_IMAGE:
    "Are you sure to remove the background image?",
  BG_UPLOAD: "Upload the background image",
  DEFAULT_BG_WILL_BE_APPLIED: "Defalut background image will be applied",
  U_ARE_PREPARED_TO_TRANSLATE_UR_WEBSITE_CONTENT:
    "You are prepared to translate your website content",
  WARNING: "Warning",
  IF_YOU_HAVE_INPUTTED_ANY_TEXT_INTO_THE_LANGUAGE_YOU_SELECTED_WILL_BE_OVERWRITTEN:
    "If you have inputted any text into the language you selected will be overwritten",
  I_UNDERSTAND_THE_ACTION_AND_AGREE_TO_TRANSLATE_USING_AI:
    "I understand the action and agree to translate using AI",
  ALL_7_DAYS: "All 7 Days",
  ARTICLE_TITLE: "Article Title",
  NO_WORKING_DAYS: "No Working Days",
  WEBSITE_PUBLISHED: "Website published",
  WEBSITE_UNPUBLISHED: "Website unpublished",
  TEMPLATE_SWITCHED_AND_PUBLISHED: "Template updated and published",
  TRANSLATING_X_PLS_BE_PATIENT: "Translating {{X}}. Please wait...",
  SAVING_TRANSLATION: "Saving translation. Please wait...",
  TOGGLE_LANGUAGE: "Switch Language",
  TRANSLATE_UR_WEBSITE_USING_AI: "Translate your website using AI...",
  ARTICLE: "Article",
  VIEW_PATIENT_HISTORY: "View Patient History",
  PRESCRIPTION_INFO: "Medical History Info",
  TRANSLATE_FROM: "Translated from",
  TRANSLATE_TO: "Translated to",
  SWAP: "Swap",
  NO_WORKING_TIME_AVAILABLE: "No Working Time Available",
  MY_COLLEAGUES: "My Colleagues",
  DAILY_SHARING: "Daily Sharing",
  EDIT_MY_COLLEAGUES: "Edit My Colleagues",
  ADD_NEW_SHARING: "Add New Daily Sharing",
  EDIT_DAILY_SHARING: "Edit Daily Sharing",
  ADD_IMAGE: "Add Image",
  COLLEAGUE_DESCRIPTION: "Colleague Description",
  REUPLOAD: "Re-Upload",
  COLLEAGUE: "Colleague",
  PAY_THE_BALANCE: "Pay the Balance",
  PAYMENT_SUCCESSFUL: "Payment Successful",
  DELETE_DAILY_SHARING: "Delete Daily Sharing",
  ARE_YOU_SURE_TO_DELETE_THIS_DAILY_SHARING:
    "Are you sure to delete this daily sharing?",
  EDIT_VIDEO: "Edit Video",
  ADD_VIDEO: "Add Video",
  VIDEO: "Video",
  COVER_IMAGE: "Cover Image",
  VIDEO_TITLE: "Video Title",
  VIDEO_DESC: "Video Description",
  WATCH: "Watch",
  DELETE_VIDEO: "Delete Video",
  ARE_YOU_SURE_TO_DELETE_THIS_VIDEO:
    "Are you sure you want to delete this video?",
  USED_BY_PHONE: "Used by phone",
  DISCONNECT_YOUR_PHONE_TO_TYPE_IN: "Disconnect your phone to type in",
  DISCONNECT: "Disconnect",
  CONTENT: "Content",
};

const notification = {
  CLINIC_SWITCHED_TO_X: "Current clinic has been switched to {{X}}",
  ONLY_IMAGE_FILES_ALLOWED: "You can only upload image files here",
  HISTORY_SAVED: "Medical history saved",
  TRANSLATION_COMPLETED: "Translation completed",
  "UPDATE_HISTORY_#X": "Update History #{{X}}",
  ARTICLE_TITLE_CANNOT_BE_EMPTY: "Article title cannot be empty",
  ARTICLE_UPDATED: "Article updated",
  ARTICLE_CREATED: "Article created",
  ARTICLE_PUBLISHED: "Article published",
  ARTICLE_UNPUBLISHED: "Article unpublished",
  ARTICLE_DELETED: "Article deleted",
  PREVIEW_TEMPLATE: "Preview Mode",
  U_R_IN_PREVIEW_MODE: "You are in preview mode",
  U_R_IN_EDIT_MODE: "You are in edit mode",
  PROFILE_IMAGE_UPLOADED: "Profile image uploaded",
  SAVE_SUCCESS: "Save success",
  INCORRECT_USERNAME_OR_PASSWORD: "Incorrect username or password",
  CLINIC_X_SELECTED: "Clinic {{X}} selected for work",
  AUTHENTICATION_EXPIRED: "Authentication expired! Please try re-login again",
  MAKE_AN_APPOINTMENT: "Make an appointment",
  APPOINTMENT_TIME: "Appointment Time",
  PHONE: "Phone",
  EMAIL: "Email",
  FIRST_NAME_IS_REQUIRED: "First name is required",
  LAST_NAME_IS_REQUIRED: "Last name is required",
  PHONE_IS_REQUIRED: "Phone is required",
  INVALID_PHONE_NUMBER: "Invalid phone number",
  PLEASE_FIX_ERRORS: "Please fix the errors",
  BOOKING_CREATED: "Booking created",
  FIRSTNAMEEN_IS_REQUIRED: "First name (English) is required",
  LASTNAMEEN_IS_REQUIRED: "Last name (English) is required",
  INVALID_EMAIL: "Invalid email",
  EMAIL_IS_REQUIRED: "Email is required",
  ADDRESS_IS_REQUIRED: "Address is required",
  LESS_DETAILS: "Less Details",
  REMOVE: "Remove",
  COMPANY_NAME_IS_REQUIRED: "Company name is required",
  INSURANCE_NUMBER_IS_REQUIRED: "Insurance number is required",
  CONFIGURATION: "Configuration",
  SELECT_SECTION_U_ARE_GOING_TO_CONFIGURE:
    "Select the section you are going to configure",
  BUSINESS: "Business",
  CONFIGURE_BUSINESS_TIME: "Configure Business Time",
  LANGUAGE: "Language",
  CURRENT_LANGUAGE_X: "Current Language: {{X}}",
  PATIENT_CREATED: "Patient created",
  PATIENT_EDITED: "Patient edited",
  CHECK_IN_SUCCESS: "Check in success",
  WHETHER_TO_DISPLAY_THIS_SECTION: "Whether to Display this Section",
};

const appointment = {
  APPOINTMENT_INFO: "Appointment Info",
  APPOINTMENT_STATUS: "Appointment Status",
  CHECKED_IN: "Checked In",
  CHECK_IN: "Check In",
  PROCEED_TO_MEDICAL_HISTORY: "Proceed to Medical History",
  APPOINTMENT_CLINIC: "Appointment Clinic",
  NAME: "Name",
  U_MIGHT_LOOKING_FOR_PATIENT: "👀 Are you looking for patient below?",
  NO_RELAVANT_PATIENT_IN_CLINIC: "👀 It looks like you have a new patient.",
  PLS_ADD_PATIENT_FIRST: "Do you want to add him/her to your clinic?",
  SELECT_EXISTING_PATIENT_FROM_CLINIC_TO_CREATE_MEDICAL_HISTORY:
    "Select patient from clinic to proceed in creating medical history",
  CREATE_MEDICAL_HISTORY: "Create Medical History",
  NONE_OF_PATIENT_ABOVE_IS_CORRECT: "None of the patient above?",
  PENDING_CHECK_IN: "Booking Confirmed",
  PENDING_CHECK_IN_WAITING: "Waiting in Clinic",
  ARE_YOU_SURE_TO_CHECK_IN_THIS_APPOINTMENT_FOR_X:
    "Are you sure to check in to this appointment for {{X}}?",
  AFTER_CHECKED_IN_YOU_CAN_PROCEED_MEDICAL_HISTORY_FOR_THIS_PATIENT:
    "After checked in, you can proceed to create medical history for this patient.",
  LOADING_APPOINTMENT: "Loading Appointment",
  TODAY: "Today",
  REMEDIAL_MASSAGE: "Remedial Massage",
  MASSAGE: "Massage",
  ACUPUNCTURE: "Acupuncture",
  CHINESE_MEDICINE: "Chinese Medicine",
  APPROXIMATE_DURATION: "Approximate Duration",
  APPROX: "Approx.",
  BUSINESS_TIME: "Business Time",
  WORKING_SERVICES: "Working Items",
  WORKING_DAYS: "Working Days",
  WORKING_TIME_PERIOD: "Working Time Period",
  RESET: "Reset",
  BLOCK_TIME_SLOTS: "Block Time Slots",
  APPLY_BLOCK_TIMES_TO_ALL_DAYS: "Apply Block Times to All Days",
  LOADING_TIME_SLOTS: "Loading Timeslots",
  NO_AVAILABLE_TIME: "No Available Time",
  RESET_CLINIC: "Reset Clinic",
  CLINIC_NOT_FOUND: "Clinic Not Found",
  SAVE_CLINIC_SUCCESS: "Business time saved",
  PLEASE_SELECT_WORKING_SERVICES: "Please select working services",
  START_TIME_CANNOT_BE_AFTER_END_TIME: "Start time cannot be after end time",
  END_TIME_CANNOT_BE_BEFORE_START_TIME: "End time cannot be before start time",
  SELECTED_WEEKDAY: "Selected Weekday",
  MINUTES: "min",
  CLEAR_ALL: "Clear All",
  CLICK_ON_TIMESLOT_THAT_YOU_DONT_WANT_IT_BE_AVAILABLE_FOR_APPOINTMENT:
    "Click to block the timeslot that you don't want it to be available for appointment",
  SELECT_WORKING_DAY: "Select Working Day",
  DECREASE_DURATION: "Decrease Duration",
  INCREASE_DURATION: "Increase Duration",
  CURRENT_BLOCK_TIME_APPLIED_TO_ALL_DAYS:
    "Current block time has been applied to all days",
  SAVE_AS_NOT_WORKING: "Save as Not Working",
  SAVE_AS_WORKING: "Save as Working",
  CONFIRM_CLEAR_BLOCK_TIMES: "Are you sure to clear all block times?",
  CHANGING_DURATION_WILL_CLEAR_ALL_BLOCK_TIMES:
    "Changing duration will clear all block times",
  CHANGING_WORKING_TIME_WILL_CLEAR_TODAY_BLOCK_TIMES:
    "Changing working time will clear today's block times",
  BLOCK_TIMES_CLEARED: "Block times cleared",
  SAVING: "Saving",
  BLOCK_THIS_TIMESLOT: "Block this timeslot",
  ACTIVE_THIS_TIMESLOT: "Active this timeslot",
  UNSAVED_CHANGES: "Unsaved Changes",
  YOU_HAVE_UNSAVED_CHANGES_CONTINUE:
    "You have unsaved changes. Are you sure you want to switch clinics and discard them?",
  DISCARD_AND_SWITCH: "Discard and Switch",
  YOU_HAVE_NO_CONFIGURE_YOUR_WORKING_TIME_IN_THIS_CLINIC:
    "You have no configure your working time in this clinic",
  CONFIGURE_WORKING_TIME: "Configure Working Time",
  MY_WORKING_CLINICS: "My Working Clinics",
  ALL: "All",
  FILTER: "Filter",
  STATUS: "Status",
  SELECT_HOUR: "Select Hour",
  SELECT_MINUTE: "Select Minute",
  SELECT_APPOINTMENT_TIME: "Select Appointment Time",
};

const clinicManagement = {
  CLINIC_MANAGEMENT: "Clinic Management",
  SEARCH_CLINIC_IN_SEARCH_BAR_TO_JOIN_IN_OR_CREATE_NEW_CLINIC:
    "Search Clinic in Search Bar to Join or Create New Clinic",
  NO_CLOSED_CLINICS: "No Closed Clinics",
  NO_PENDING_CLINICS: "No Pending Clinics",
  SEARCH_CLINIC: "Search Clinic",
  ADD_CLINIC: "Add Clinic",
  CLINIC_INFO: "Clinic Info",
  OWNER: "Owner",
  INVITE_PRACTITIONERS: "Invite Practitioners",
  INVITED: "Invited",
  NO_PRACTITIONER_FOUND: "No Practitioner Found",
  SUBMIT_CLINIC_INFO: "Submit Clinic Info",
  UPDATE_CLINIC_INFO: "Update Clinic Info",
  RESUBMIT_CLINIC_INFO: "Resubmit Clinic Info",
  ADDRESS: "Address",
  OPEN: "Open",
  PENDING: "Pending",
  MY_CLINIC: "My Clinic",
  EDIT_INFO: "Edit Info",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  ASSOCIATED_PRACTITIONERS: "Associated Practitioners",
  NO_PHONE_NUMBER: "No Phone Number",
  PRACTITIONER_INFO: "Practitioner Info",
  SERVICES: "Services",
  WORK_TIME: "Work Time",
  WORKING_DAY: "Working Day",
  NOT_AVAILABLE: "Not Available",
  MINS: " mins",
  X_PRACTITIONERS_ARE_NOW_ACTIVE: "{{X}} Practitioners are Now Active",
  NO_ACTIVE_PRACTITIONERS: "No Active Practitioners",
  NO_INACTIVE_PRACTITIONERS: "No Inactive Practitioners",
  INVITE_PRACTITIONERS: "Invite Practitioners",
  INVITE: "Invite",
  WORKING_IN_CLINIC: "Working in Clinic",
  QUIT_PRACTITIONER: "Quit Practitioner",
  QUIT_FROM_CLINIC: "Quit from Clinic",
  QUIT_CLINIC_CONFIRM: "Quit Clinic Confirm",
  QUIT_CLINIC_REQUEST_SENT: "Quit Clinic Request Sent",
  ARE_YOU_SURE_TO_QUIT_CLINIC: "Are you sure to quit this clinic",
  YOU_WILL_NOT_BE_ABLE_TO_BE_BOOKED_BY_PATIENT_FOR_THIS_CLINIC_ANYMORE:
    "You will not be able to be booked by patient for this clinic anymore",
  PENDING_APPROVE_TO_QUIT: "Pending Approve to Quit",
  PENDING_APPROVE_TO_JOIN: "Pending Approve to Join",
  JOIN_CLINIC: "Join Clinic",
  X_NEW_MEMBER_REQUESTS: "{{X}} New Member Requests",
  JOIN_CLINIC_CONFIRM: "Join Clinic Confirm",
  ARE_YOU_SURE_TO_JOIN_CLINIC: "Are you sure to join this clinic",
  YOUR_JOIN_REQUEST_HAS_BEEN_SENT: "Your join request has been sent",
  NEW_PRACITTIONERS: "New Practitioners",
  ACCEPT_CONFRIM: "Accept Confirm",
  ARE_YOU_SURE_TO_ACCEPT_PRACTITIONER_REQUEST:
    "Are you sure to accept this practitioner request",
  ARE_YOU_SURE_TO_REJECT_PRACTITIONER_REQUEST:
    "Are you sure to reject this practitioner request",
  VIEW_INFO: "View Info",
  NO_SERVICES_AVAILABLE: "No Services Available",
  SEARCH_PRACTITIONER_BY_NAME: "Search Practitioner by Name",
  X_PENDING_APPROVAL: "{{X}} Requets Pending Approval",
  APPROVE: "Approve",
  DECLINE: "Decline",
  ACCEPT: "Accept",
  CLEAR: "Clear",
  ACCEPT_CONFIRM: "Accept Confirm",
  REJECT_CONFIRM: "Reject Confirm",
  CLOSE_CLINIC: "Close Clinic",
  CONFIRM_TO_CLOSE_CLINIC: "Confirm to Close Clinic",
  THIS_CLINIC_WILL_BE_CLOSED_AND_ALL_ASSOCIATED_PRACTITIONERS_WILL_BE_REMOVED:
    "This clinic will be closed and all associated practitioners will be removed",
  I_UNDERSTAND_THE_CONSEQUENCES_OF_CLOSING_THIS_CLINIC:
    "I understand the consequences of closing this clinic",
  ME: "Me",
  ARE_YOU_SURE_TO_REMOVE_PRACTITIONER_FROM_CLINIC:
    "Are you sure to remove this practitioner from this clinic",
  THIS_PRACTITIONER_WILL_NOT_BE_ABLE_TO_VIEW_USE_INFO_FOR_THIS_CLINIC:
    "This practitioner will not be able to working in this clinic anymore",
  INVITE_CONFIRM: "Invite Confirm",
  ARE_YOU_SURE_TO_INVITE_X_TO_YOUR_CLINIC:
    "Are you sure to invite {{X}} to your clinic",
  CONTINUE: "Continue",
  PENDING_ACCEPT: "Pending Practitioner to Accept",
  NO_CLINIC_SELECTED: "No Clinic Selected",
  NO_WORKING_CLINIC_FOUND: "No Working Clinic Found",
  NEW_CLINIC_INVITATION: "New Clinic Invitation",
};

const clinicHerbs = {
  HERB_MANAGEMENT: "Herb Management",
  MANAGE_YOUR_CLINIC_HERBS_FORMULA:
    "Manage herbs and formulas information that is available in your current clinic only",
  CURRENT_CLINIC: "Current Clinic",
  CONFIGURE_CLINIC_HERBS: "Configure Clinic Herbs",
  CONFIGURE_CLINIC_FORMULA: "Configure Clinic Formulas",
  CLINIC_HERB: "Clinic Herb",
  CLINIC_FORMULA: "Clinic Formula",
  SEARCH_HERB_NAME: "Search Herb Name",
  SEARCH_FORMULA_NAME: "Search Formula Name",
  ADD_HERB: "Add Herb",
  ADD_FORMULA: "Add Formula",
  HERB_NAME: "Herb Name",
  HERB_NAME_IN_X: "Herb Name ({{X}})",
  PINYIN: "Pinyin",
  IS_TOXIC: "Is Toxic",
  IS_PREMIUM: "Is Premium",
  USED_BY_CREATER_ONLY: "Used by Creater Only",
  TOXIC: "Toxic",
  PREMIUM: "Premium",
  YES: "Yes",
  NO: "No",
  HERB_NAME_CN: "Herb Name (Chinese)",
  FORMULA_NAME_CN: "Formula Name (Chinese)",
  HERB_NAME_EN: "Herb Name (English)",
  FORMULA_NAME_EN: "Formula Name (English)",
  HERB_INFO: "Herb Info",
  FORMULA_INFO: "Formula Info",
  THIS_FORMULA_CAN_ONLY_BE_USED_EDITED_BY_YOURSELF:
    "This formula can only be used/edited by the creator (myself)",
  SEARCH_HERB_NAME_HERE: "Search herb name here",
  SEARCH_HERB_BY_HERB_NAME: "Search Herb by Herb Name",
  HERB_IN_THIS_FORMULA: "Herb in this Formula",
  NO_HERB_ADDED: "No Herb Added",
  FORMULA_NAME: "Formula Name",
  FORMULA_NAME_IN_X: "Formula Name ({{X}})",
  NUM_HERBS: "Number of Herbs",
  ADDED: "Added",
  FORMULA_CREATED: "Formula created",
  FORMULA_UPDATED: "Formula updated",
  HERB_CREATED: "Herb created",
  HERB_UPDATED: "Herb updated",
  UNDO: "Undo Remove",
  PLZ_INPUT_FORMULA_NAME_CN: "Please input the formula name in Chinese",
  PLZ_INPUT_FORMULA_NAME_EN: "Please input the formula name in English",
  PLZ_INPUT_PINYIN: "Please input the pinyin",
  PLZ_INPUT_HERB_NAME_CN: "Please input the herb name in Chinese",
  PLZ_INPUT_HERB_NAME_EN: "Please input the herb name in English",
};
const packagePages = {
  INCLUDES: "Includes",
  INCLUDES_ALL_LOWER_AND: "Includes all lower-level features and",
  PP_PER_YEAR: "PP / Year",
  PP_PER_MONTH: "PP / Month",
  PACKAGES: "Packages",
  EXPIRE_IN_X_DAYS: "Expire in {{X}} days",
  FOR_NEXT_X_DAYS: "For next {{X}} days",
  SELECT_CLINIC_FOR_APPLYING_PACKAGE:
    "Select the clinic for applying the package",
  NUMBER_OF_USER: "Number of Users",
  SELECTED_PACKAGE: "Selected Package",
  CURRENT_USER: "Current User",
  NEW_PACKAGE: "New Package",
  NO_CLINIC_MEMBERS: "No clinic members found",
  ASSIGN_PACKAGE_TO_USER: "Assign Package to User",
  PER_EXIST_USER: "Per Existing User",
  PER_NEW_USER: "Per New User",
  NO_PACKAGES_FOUND: "No packages found",
  EXTEND: "Extend",
  UPGRADE: "Upgrade",
  RENEW: "Renew",
  PP: "Per Person",
  SELECT_A_PACKAGE: "Select a Package",
  CHANGE: "Change",
  ASSIGN: "Assign",
  PURCHASE_PACKAGES: "Purchase Packages",
  NO_PACKAGE: "No Packages",
  EXPIRE_DATE: "Expire Date",
  MAX_USERS: "Max Users",
  TIME: "Time",
  PRICE: "Price",
  PAYMENT_HISTORY: "Payment History",
  CHECK_YOUR_PAYMENT_HISTORY: "Check Your Payment History",
  THIS_PACKAGE_IS_ONLY_FOR_YOURSELF_NOT_FOR_YOUR_CLINIC_MEMBER:
    "This package is only for yourself, not for your clinic members.",
  PURCHASE: "Purchase",
  RENEW: "Renew",
  UPGRADE: "Upgrade",
  TYPE: "Type",
};

const cmasaImport = {
  IMPORT_CLINICS: "Import Clinics",
  CLINICS_FOUND_IN_X: "Clinics found in {{X}}",
  NO_CLINIC_FOUND: "No clinic found",
  CLINICS_IMPORTED_FROM_X: "Clinics imported from {{X}}",
  NO_CLINIC_IMPORTED: "No clinic imported",
  DELETE: "Delete",
  CONFIRM: "Confirm",
  ARE_YOU_SURE_TO_DELETE_X: "Are you sure to delete {{X}}?",
  THIS_ACTION_CANNOT_BE_UNDONE: "This action cannot be undone",
  IMPORT_CLINIC: "Import Clinic",
  UPDATE_CLINIC: "Update Clinic",
  UPLOAD_AVATAR: "Upload Avatar",
  REUPLOAD_PROFILE_IMAGE: "Re-upload Profile Image",
  CLICK_TO_UPLOAD: "Click to upload",
  PLEASE_FILL_ALL_REQUIRED_FIELDS: "Please fill in all required fields",
  PLEASE_ENTER_VALID_EMAIL: "Please enter a valid email address",
  PLEASE_ENTER_SAME_PASSWORD: "Please enter the same password",
  SIGN_UP_SUCCESS: "Sign-up successful",
  CLINIC_EXISTS: "This clinic already exists",
  NEXT_STEP: "Next Step",
  SAME_WITH_ORG_PASSWORD: "Same as original password",
  PROFILE_IMG: "Profile Image",
  I_CHANGED_MY_MIND: "I changed my mind",
  ADDING: "Adding...",
  JOINING: "Joining...",
  OR: "or",
  SKIP: "Skip",
  JOIN: "Join",
  SAVE_CONFIRM: "Save Confirm",
  ARE_YOU_SURE_TO_SUBMIT_YOUR_CLINIC_INFO:
    "Are you sure to submit your clinic info",
  FOUND_RELEVANT_CLINICS:
    "We’ve found some clinics in the VAI system that may be relevant to this clinic.",

  JOIN_OR_SKIP_CLINIC_GUIDE:
    "You can click Join to request to join one of them. If you’re unsure or don’t see the right clinic, you can click Skip and choose to handle this later.",
  NEED_TO_ADD_CLINIC: "Do you need to add this clinic to our VAI system?",
  ADD_CLINIC_DESCRIPTION:
    "Click Add to proceed. You will become the owner of the clinic, with the ability to invite or remove members. You can also transfer ownership to another clinic member at a later time. If you’re unsure or don’t need to add it now, click Skip and come back to it later.",
  CLINIC_RESULT_TITLE: "Result for this clinic",
  CLINIC_SKIPPED_MSG:
    "This clinic has been skipped. You will neither join an existing clinic nor add it as a new one.",
  CLINIC_NOT_LISTED: "The clinic I want to join is not listed above.",
  I_DO_NOT_WANT_TO_USE_THE_CLINIC_INFO_ABOVE:
    "I do not want to use the clinic info above",
  PREVIOUS_CLINIC: "Previous Clinic",
  NEXT_CLINIC: "Next Clinic",
  ARE_YOU_SURE_TO_CHANGE_YOUR_MIND:
    "Are you sure you want to change your mind? This will reset the setup you’ve done for this clinic.",
};
const camera = {
  FOR_PATIENT: "For patient {{name}}",
  UPLOAD_PHOTO_LABEL: "Upload",
  TAKE_PHOTO: "Take photo",
  OR_CHOOSE_FROM_ALBUM: "Or choose from album",
  CHOOSE_PHOTO: "Choose photo",
  PREVIEW: "Preview",

  DISCONNECTED_TITLE: "Connection Lost / Link Expired",
  DISCONNECTED_BODY:
    "This photo upload link has expired, or been closed. Please generate a new QR code or link.",
  CLICK_AND_UPLOAD_WITH_YOUR_PHONE: "Click and upload with your phone",
  CLICK_AND_RECORD_WITH_YOUR_PHONE: "Click and record with your phone",
  REFRESH_QR_CODE: "Refresh QR Code",
  CAMERA_TOKEN_EXPIRED: "Camera token has expired",
  IF_YOU_ALREADY_CONNECTED_WITH_YOUR_PHONE:
    "If your phone is already connected, it will automatically navigate to the corresponding page when a new QR code is generated. If any issue arises, please rescan the QR code with your phone.",
};

const Library = {
  MEDICAL_PUBLICATIONS: "Medical Publications",
  SEARCH_MEDICAL_PUBLICATIONS: "Search Medical Publications",
  SEARCH_PUBLICATION_BY_NAME: "Search Publication by Name",
  RECENT: "Recent",
  LIBRARY: "Library",
  NO_PUBLICATIONS_FOUND: "No Publications Found",
  NO_RECENT_PUBLICATIONS: "No Recent Publications",
  NO_PUBLICATIONS_IN_LIBRARY: "No Publications in Library",
  SEARCH_FOR_THE_MEDICAL_PUBLICATIONS_IN_SEARCH_BAR_OR_VISIT_OUR_LIBRARY:
    "Search for the medical publications in search bar or visit our library",
  JUST_NOW: "Just now",
  RECENT_X_MINUTES: "Recent {{x}} minutes",
  RECENT_X_HOURS: "Recent {{x}} hours",
  RECENT_X_DAYS: "Recent {{x}} days",
  ADD_THIS_BOOK_TO_YOUR_FAVORITES: "Add this book to your favorites",
  CHAPTERS: "Chapters",
  BOOKMARK: "Bookmark",
  ADD_BOOKMARK: "Add Bookmark",
  FULL_SCREEN: "Full Screen",
  TEXT_SIZE: "Text Size",
  NEXT_PAGE: "Next Page",
  PREVIOUS_PAGE: "Previous Page",
  FONT_SIZE: "Font Size",
  SMALL: "Small",
  MEDIUM: "Medium",
  LARGE: "Large",
  BOOKS_MANAGEMENT: "Books Management",
  SAVE_BOOK: "Saved Book",
  READER: "Reader",
  REGULAR: "Regular",
  SEARCH_FOR_PUBLICATIONS: "Search by title or author",
};

const patientAndQuickSignUp = {
  BACK: "Back",
  CLOSE: "Close",
  ONLINE_ZOOM_MEETING: "Online Zoom Meeting",
  KEY_MEMBERS: "Key Members",
  INTRODUCTION: " Brief Introduction",
  LOAD_MORE: "Load More",
  CURRENT: "Current",
  HISTORY_EVENT: "History Events",
  HISTORY_CPD: "History CPD",
  HISTORY: "In the Past",
  EXPIRED: "Expired",
  MONTH_FORMAT: "MMMM",
  EDIT: "Edit",
  FROM: "From",
  TO: "To",
  TOTAL_X: "Total {{X}} Records",
  OTHER_LANGUAGE_VERSION: "中文版",
  CLINIC: "Clinic",
  HRS: "hrs",
  VIEW: "View",
  LOADING: "Loading",
  VIEW_ALL: "View All",
  SWITCH_TEMPLATE: "Switch Template",
  TERMS_AND_CONDITIONS: "Terms and Conditions",
  PRIVACY_POLICY: "Privacy Policy",
  DATA_PROCESSING_ADDENDUM: "Data Processing Addendum",
  INITIATING: "Initiating",
  FAILED_TO_ACCESS_MICROPHONE: "Failed to access microphone",
  LISTENING: "Listening",
  TRANSCRIBING: "Transcribing",
  SPEECH_TO_TEXT: "Speech to Text",
  STOP_RECORDING: "Stop Recording",
  WHO_IS_THIS_APPOINTMENT_FOR: "Who is this appointment for?",
  WHO_IS_THIS_VISIT_FOR: "Who is this visit for?",
  MYSELF: "Myself",
  SOMEONE_ELSE: "Someone else",
  ABOUT_YOU: "About You",
  ABOUT_THE_PATIENT: "About the Patient",
  NEXT: "Next",
  PREVIOUS: "Previous",
  PRACTITIONER: "Practitioner",
  APPROVED: "Approved",
  PENDING: "Pending",
  LOADING: "Loading",
  I_AGREE_TO_RECEIVE_SMS:
    "I agree to receive SMS notifications about updates to this appointment.",
  I_AGREE_TO_RECEIVE_SMS_EMAIL:
    "I agree to receive SMS / emails notifications about updates to this appointment.",
  I_AGREE_TO_RECEIVE_SMS_EMAIL_VISIT: "I agree to receive SMS.",
  WELCOME_TO_CLINIC_X: "Welcome to {{X}}",
  UR_PRACTITIONER_X: "Your Practitioner: {{X}}",
  SAME_WITH_YOU: "same with you",

  ALL_GOOD: "All good",
  YOUR_APPOINTMENT_HAS_BEEN_CHECK_IN: "Your appointment has been checked in",
  VERIFY: "Verify",
  NEXT: "Next",
  REGISTER: "Register",
  PLEASE_AGREE_TO_RECEIVE_SMS: "Please agree to receive SMS",
  MAKE_APPOINTMENT_NOW: "Make Appointment Now",
  I_HAVE_NO_BOOKING:
    "Sorry, it looks like you have no appointment booked today.",
  DONT_WORRY_YOU_CAN_CREATE_QUICK_APPOINTMENT:
    "No worries! You can book an appointment in just a few minutes.",
  ENTER_MOBILE_PHONE_NUMBER_TO_CONTINUE:
    "Enter your mobile phone number to continue",
  VERIFY_CODE: "Verify code",
  SEND: "Send SMS",
  PLEASE_SELECT_UR_BOOKING_INFO:
    "Please check your appointment information below",
  OLD_PHONE_CONFIRM_TITLE:
    "We detected that you may have previously used the old mobile number {{X}}. If this is your number, please enter the full number to confirm that you agree to replace it with your current mobile number.",
  CONFIRM_REPLACE_PHONE_CHECKBOX:
    "I confirm that I want to replace the old mobile number ({{X}}) with my current mobile number, and update all records across related clinics.",
  SOMETHING_WENT_WRONG: "Something went wrong",
  PLEASE_TRY_AGAIN_LATER:
    "The QR code has expired. Please contact the clinic or try again later.",
  CERATE_A_BOOKING: "Create a appointment",
  NO_SERVICES_AVAILABLE: "No services available",
  PLEASE_SELECT_AT_LEAST_ONE_SERVICE: "Please select at least one service",
  YOUR_APPOINTMENT_HAS_BEEN_CHECK_IN:
    "You have checked in for your appointment and please wait for practitioner to be available.",
  BOOKING_ATTENDED: "Appointment attended (waiting)",
  CHECK_INFO_TITLE: "Please verify the following information",
  SMS_VERIFIED: "SMS verified",
  SMS_SENT: "SMS sent",
  SELECT_TIME_SLOT: "Select a time slot",
  SELECT_SERVICES: "Select services",
  REMEDIAL_MASSAGE: "Remedial Massage",
  NO_AVAILABLE_WORKING_TIME:
    "No appointment times are currently available. The practitioner may be fully booked today, or the current time may be outside their available booking hours.",
  I_AM_CMASA_MEMBER: "I am CMASA member",
  I_AM_NOT_CMASA_MEMBER: "I am not CMASA member",
  CMASA_MEMBER_ID: "CMASA Member ID",
  PREVIOUS_STEP: "Previous Step",
  ADD_CLINIC: "Add Clinic",
  OWNER: "Owner",
  ME: "Me",
  ADD_PACKAGE: "Add Package",
  AND_PAY: " And Pay",
  PAY_FOR_PACKAGES: "Pay for Packages",
  USER_EXIST: "The user already exists. Please go to the home page to log in.",
  PRACTITIONER_ACCOUNT_CREATED:
    "The account for practitioner {{X}} has been successfully registered.",
  PLS_VISIT_PRACTITIONER_PORTAL_TO_USE_THE_SYSTEM:
    "Please open the practitioner web portal on your computer and log in with your username to get started.",
  SIGN_IN_NOW: "Sign In Now",
  EXTRA_3_MONTHS_ON_SITE_PURCHASE:
    "Get an extra 3 months with on-site purchase",
  USERNAME_IS_NOT_AVAILABLE: "Username is not available",
  MEMBER_NOT_FOUND:
    "Unable to find member information. Please verify the mobile number and ID.",
  SUBSCRIBE_PACKAGE_FOR_CLINIC:
    "Subscribe to a package for your clinic to enjoy more comprehensive and convenient services.",
  RETRIEVE_INFO_FROM_CMASA:
    "We will retrieve your information from CMASA to assist with your registration.",
  FOUND_CLINICS_IN_CMASA:
    "We found clinics associated with you in CMASA. You may select one to add to our system now (additional clinics can be added later).",
  NO_PACKAGE_SUBSCRIBED: "No package subscribed",
  SUBSCRIBE: "Subscribe",
  CURRENT_PACKAGE: "Current package",
  PLEASE_FILL_IN_ALL_REQUIRED_FIELDS: "Please fill in all required fields",
  FINISH_CHECK_IN: "Finish Check In",
  U_CAN_CLOSE_THIS_PAGE_AT_ANY_TIME: "You can leave this page at any time",
  PLS_REFER_TO_THE_APPOINTMENT_DETAIL_BELOW:
    "Kindly refer to the appointment details provided below.",
};

const homePage = {
  PRACTITIONERS: "Practitioners",
  PATIENTS: "Patients",
  SUPPLIERS: "Suppliers",
  OUR_FEATURES: "Our Features",
  PARTNERS: "Partners",
  PARTNER_AND_TESTIMONY: "Partner & Testimony",
  FAQS: "FAQs",
  THE_ALL_IN_ONE_PLATFORM_FOR_MODERN_TCM_PRACTICES:
    "The all-in-one practice management platform for Australian Allied Health",
  SMARTER_CLINICS_BETTER_HEALING: "Smarter clinics, better healthcare",
  MENU: "Menu",
  TERMS_AND_SERVICES: "Terms and Services",
  BOOK_DEMO: "Book a Demo",
  DEMO_DESCRIPTION:
    "Join a personalized online demo to explore how our intelligent system integrates seamlessly into your workflow. Our team will tailor the session to your needs and answer all your questions in real time.",
  GO_BOOK_DEMO: "🚀 Schedule a Demo",
  ARE_U_INTERESTED:
    "Interested in our system but not sure if it’s the right fit for you?",
};

const ourFeaturesPage = {
  CUSTOMISED: "Customised",
  CUSTOMISED_PRACTITIONER_WEBSITE: "Customised \nPractitioner Website",
  BUILD_A_PROFESSIONAL_ONLINE_PRESENCE:
    "Build a professional online presence in minutes to showcase your expertise.",
  STREAMLINE_APPOINTMENT_SCHEDULING:
    "Streamline appointment scheduling with an intuitive online booking system. Patients can choose available time slots, receive instant confirmations, and get reminders—reducing no-shows and minimizing administrative overhead.",

  CLINIC: "Clinic",
  CLINIC_COLLABORATION: "Clinic \nCollaboration",
  CREATE_AND_MANAGE_MULTI_PRACTITIONER_CLINICS:
    "Create and manage multi-practitioner clinics, invite colleagues, and share resources.",
  BUILD_AND_MANAGE_MULTI_PRACTITIONER_CLINICS:
    "Build and manage multi-practitioner clinics effortlessly. Invite colleagues to join, assign roles, and share patient bookings and EMR access securely. Enable smooth collaboration among team members while maintaining data privacy.",

  ONE_CLICK: "One-Click",
  ONE_CLICK_ONLINE_BOOKING: "One-Click \nOnline Booking",
  PATIENTS_CAN_BOOK_APPOINTMENTS_DIRECTLY_REDUCING_ADMIN_WORK:
    "Patients can book appointments directly, reducing admin work.",
  STREAMLINE_APPOINTMENT_SCHEDULING:
    "Streamline appointment scheduling with an intuitive online booking system. Patients can choose available time slots, receive instant confirmations, and get reminders—reducing no-shows and minimizing administrative overhead.",

  AI: "AI",
  AI_ASSISTANT: "AI Assistant",
  GET_INSTANT_CLINICAL_REFERENCES_AND_OPERATIONAL_SUPPORT_POWERED_BY_AI:
    "Get instant clinical references and operational support powered by AI",
  AI_ASSISTANT_DESCRIPTION:
    "Get instant clinical references and operational support powered by AI.",

  PRESCRIPTIONS: "Prescriptions",
  CONSULTATION_AND_PRESCRIPTIONS: "Consultation \n& Prescriptions",
  RECORD_PATIENT_CONDITIONS_AND_ISSUE_PRESCRIPTIONS_FOR_ACUPUNCTURE_MASSAGE_HERBAL_MEDICINE_AND_MORE:
    "Record patient conditions and issue prescriptions for acupuncture, massage, herbal medicine, and more.",
  CONSULTATION_AND_PRESCRIPTIONS_DESCRIPTION:
    "Support both in-person and virtual consultations. Record patient symptoms, assessments, and treatment outcomes directly in the system. Quickly generate prescriptions for acupuncture, massage, herbal medicine, or combined therapies, with integration to billing and dispensing.",

  EMR: "EMR",
  ELECTRONIC_MEDICAL_RECORDS_EMR: "Electronic Medical Records (EMR)",
  SECURE_AND_COMPLETE_DIGITAL_RECORDS_FOR_DIAGNOSES_TREATMENTS_AND_FOLLOW_UPS:
    "Secure and complete digital records for diagnoses, treatments, and follow-ups.",
  MAINTAIN_ACCURATE_SECURE_AND_COMPREHENSIVE_DIGITAL_MEDICAL_RECORDS_DOCUMENT_PATIENT_HISTORY_DIAGNOSES_TREATMENT_NOTES_AND_FOLLOW_UP_PLANS_IN_ONE_PLACE_EASILY_RETRIEVE_PAST_RECORDS_TO_SUPPORT_BETTER_CLINICAL_DECISIONS_AND_CONTINUITY_OF_CARE:
    "Maintain accurate, secure, and comprehensive digital medical records. Document patient history, diagnoses, treatment notes, and follow-up plans in one place. Easily retrieve past records to support better clinical decisions and continuity of care.",

  MARKETPLACE: "Herbal Medicine Marketplace",
  HERBAL_MEDICINE_MARKETPLACE: "Herbal Medicine Marketplace",
  ORDER_HIGH_QUALITY_HERBS_AND_EQUIPMENT_DIRECTLY_FROM_VERIFIED_SUPPLIERS:
    "Order high-quality herbs and equipment directly from verified suppliers.",
  ACCESS_A_CURATED_MARKETPLACE_OF_CERTIFIED_HERBAL_SUPPLIERS_AND_EQUIPMENT_PROVIDERS_BROWSE_PRODUCTS_COMPARE_QUALITY_AND_PLACE_ORDERS_SEAMLESSLY_ENSURE_RELIABLE_SOURCING_OF_HERBS_PATENT_MEDICINES_AND_CLINIC_ESSENTIALS_ALL_IN_ONE_PLATFORM:
    "Access a curated marketplace of certified herbal suppliers and equipment providers. Browse products, compare quality, and place orders seamlessly. Ensure reliable sourcing of herbs, patent medicines, and clinic essentials—all in one platform.",

  AUTO_GENERATE: "Auto-generate",
  AUTO_GENERATE_BILLING_AND_REPORTS: "Auto-generate \nBilling & Reports",
  AUTO_GENERATE_INVOICES_AND_FINANCIAL_REPORTS_FOR_EASY_RECONCILIATION:
    "Auto-generate invoices and financial reports for easy reconciliation.",
  GENERATE_PROFESSIONAL_INVOICES_INSTANTLY_AND_KEEP_TRACK_OF_PAYMENTS_WITH_EASE_AUTOMATED_FINANCIAL_REPORTING_PROVIDES_INSIGHTS_INTO_REVENUE_EXPENSES_AND_OVERALL_CLINIC_PERFORMANCE_HELPING_YOU_MAKE_INFORMED_BUSINESS_DECISIONS:
    "Generate professional invoices instantly and keep track of payments with ease. Automated financial reporting provides insights into revenue, expenses, and overall clinic performance, helping you make informed business decisions.",

  MANAGEMENT: "Management",
  INVENTORY_MANAGEMENT: "Inventory \nManagement",
  TRACK_STOCK_LEVELS_IN_REAL_TIME_TO_PREVENT_SHORTAGES_OR_WASTE:
    "Track stock levels in real time to prevent shortages or waste.",
  MONITOR_AND_CONTROL_YOUR_CLINICS_STOCK_IN_REAL_TIME_GET_ALERTS_FOR_LOW_INVENTORY_TRACK_USAGE_AND_MANAGE_REORDERS_AUTOMATICALLY_PREVENT_SHORTAGES_OF_ESSENTIAL_HERBS_OR_OVERSTOCKING_ENSURING_SMOOTH_CLINIC_OPERATIONS:
    "Monitor and control your clinic’s stock in real time. Get alerts for low inventory, track usage, and manage reorders automatically. Prevent shortages of essential stock or overstocking, ensuring smooth clinic operations.",

  LIBRARY: "Library",
  TCM_KNOWLEDGE_LIBRARY: "Clinical Knowledge Library",
  ACCESS_A_COMPREHENSIVE_COLLECTION_OF_CLASSICAL_TEXTS_MODERN_RESEARCH_AND_CASE_STUDIES:
    "Access a comprehensive collection of clinical references, modern research, and case studies.",
  EXPLORE_A_VAST_DIGITAL_LIBRARY_FEATUREING_CLASSICAL_TCM_TEXTS_MODERN_RESEARCH_ARTICLES_AND_PRACTICAL_CASE_STUDIES_USE_IT_AS_A_TRUSTED_REFERENCE_FOR_CLINICAL_DECISION_MAKING_ONGOING_LEARNING_AND_PROFESSIONAL_DEVELOPMENT:
    "Explore a vast digital library featuring clinical references, modern research articles, and practical case studies—including specialised resources for Traditional Chinese Medicine. Use it as a trusted reference for clinical decision-making, ongoing learning, and professional development.",

  FEATURE_GROUP_WEBSITE_BOOKINGS_TITLE: "Website & Bookings",
  FEATURE_GROUP_WEBSITE_BOOKINGS_DESCRIPTION:
    "Give patients a polished front door to your practice, and a simple way to book in.",

  FEATURE_GROUP_CLINICAL_CARE_TITLE: "Clinical Care",
  FEATURE_GROUP_CLINICAL_CARE_DESCRIPTION:
    "Capture consultations, prescriptions, and patient records in one connected clinical workflow.",

  FEATURE_GROUP_PRACTICE_OPERATIONS_TITLE: "Practice Operations",
  FEATURE_GROUP_PRACTICE_OPERATIONS_DESCRIPTION:
    "Keep billing, stock, and multi-practitioner clinics running smoothly behind the scenes.",

  FEATURE_GROUP_SMART_TOOLS_TITLE: "Smart Tools",
  FEATURE_GROUP_SMART_TOOLS_DESCRIPTION:
    "AI support built into your day-to-day clinical and administrative work.",
};

const partnerPage = {
  PARTNER: "Partner",
  HEAR_DIRECTLY_FROM_PRACTITIONERS_AND_SUPPLIERS:
    "Hear directly from practitioners and suppliers who have transformed their daily operations with our platform.",
  COMPREHENSIVE_FEATURES_FOR_ALL_YOU_NEED_TO:
    "Comprehensive features for all you need to",
  POWER_YOUR_PRACTICE: "Power your practice",
};

const testimonyPage = {
  TESTIMONY: "Testimony",
  TCM_PRACTITIONER: "Physiotherapist",
  BEFORE_ADOPTING_THIS_PLATFORM:
    "Before adopting this platform, I relied heavily on handwritten notes and paper records. It was often difficult to keep everything organized, and retrieving past information during follow-ups was time-consuming. Since moving to this system, all my patient data is secure, well-structured, and accessible anytime, even when I’m working outside the clinic. The ease of searching old case notes and treatment histories has made my consultations far more efficient. More importantly, patients feel reassured knowing their records are professionally managed and kept confidential. This transformation has truly changed the way I operate my clinic—saving me time and allowing me to focus more on my patients rather than paperwork.",

  MASSAGE_THERAPIST: "Massage Therapist",
  AS_AN_INDEPENDENT_PRACTITIONER:
    "As an independent practitioner, I used to spend a lot of time handling calls, booking appointments, and updating patients manually. It was exhausting and left me with less energy for my actual clinical work. The personal website feature of this platform has been a game-changer. Within minutes, I was able to set up a clean, professional page where patients can read about my practice, check my availability, and book appointments online at their convenience. Not only has this reduced countless phone calls, but it has also given my practice a more modern and trustworthy image. Patients appreciate the convenience, and I appreciate the efficiency. It feels like I have an assistant working for me around the clock.",

  TCM_ACUPUNCTURIST: "Podiatrist",
  AS_A_SUPPLIER:
    "As a podiatrist running my own clinic, I needed a system that could keep up with a busy patient list without adding more admin to my day. Since switching to this platform, patient records, treatment notes, and follow-up appointments are all in one place, so I can move between consultations without hunting for paperwork. The online booking feature has also made it much easier for patients to find a time that suits them. It's given me back time in my day that I now spend with patients instead of paperwork.",
};

const faqPage = {
  SOME_FREQUENTLY_ASKED_QUESTIONS: "Some Frequently Asked Questions",
  IS_THIS_PLATFORM_RIGHT_FOR_ME: "Is this platform right for me?",
  ABSOLUTELY_U_CAN_SET_UP:
    "Absolutely. You can set up your own online clinic, create a personal website, and start managing patients in minutes.",
  IS_PATIENT_DATA_SECURE: "Is patient data secure?",
  YES_MEDICAL_GRADE_ENCRYPTION_AND_STRICT_ACCESS_CONTROLS:
    "Yes. We use medical-grade encryption and strict access controls. All records comply with healthcare data protection standards.",
  DOES_THE_PLATFORM_SUPPORT_MULTI_PRACTITIONER_CLINICS:
    "Does the platform support multi-practitioner clinics?",
  YES_U_CAN_CREATE_A_TEAM_CLINIC:
    "Yes. You can create a team clinic, invite colleagues, and share patient bookings and EMR access securely. Enable smooth collaboration among team members while maintaining data privacy.",
  HOW_IS_THE_SERVICE_PRICED: "How is the service priced?",
  YOU_CAN_CHOOSE_A_SUBSCRIPTION_PLAN_THAT_SUITS_YOUR_NEEDS:
    "You can choose a subscription plan that suits your needs. ",
};

const aboutUsPage = {
  OUR_MISSION_IS_SIMPLE:
    "Our mission is simple: to help Allied Health practitioners focus on patient care, while we take care of the rest. With innovation, security, and community at the heart of everything we do, we are committed to supporting the growth of modern Australian Allied Health practices.",
  AT_OUR_CORE:
    "At our core, we believe every Allied Health practitioner deserves a modern, professional digital ecosystem—one that simplifies the everyday running of a practice while embracing today’s technology. Our platform was built to empower independent practitioners, clinics, and suppliers with the tools they need to thrive in an evolving healthcare landscape.",
  WE_PROVIDE_AN_ALL_IN_ONE_SOLUTION_DESIGNED_SPECIFICALLY_FOR_THE_TCM_COMMUNITY:
    "We provide an all-in-one practice management solution built for Australian Allied Health clinics: from practitioner websites and patient records, to online consultations, digital consent, billing, and financial reporting. The platform supports a wide range of disciplines, including Traditional Chinese Medicine, acupuncture, and remedial therapies. By connecting practitioners, patients, and suppliers on a single platform, we make clinic operations more efficient, patient experiences more seamless, and supply chains more reliable. We're also proud to work with organisations such as HICAPS, supporting Australian healthcare practices through industry partnerships.",
};

const bookingPage = {
  BOOK_DOCTOR: "Book a Doctor",
  BOOKING_A_DOCTOR: "Booking a doctor",
  SEARCH_BY_PRACTITIONER_NAME_SERVICE_TYPE_OR_SUBURB:
    "Search by practitioner name, service type, or suburb postcode",
  BY: "By ",
  SERVICE_TYPE: "Service Type",
  SEARCH_BY_PRACTITIONER_NAME: "Search by practitioner name",
  SEARCHING_PRACTITIONERS: "Searching Practitioners",
  NO_SERVICE_LISTED: "No service listed",
  BOOK: "Book",
  WEBSITE: "Website",
  PUBLISH_WEBSITE: "Publish Website",
  JOIN: "Join",
  AND_X_PRACTITIONERS_MORE: "and {{X}} practitioner(s) more...",
  MEDICINE_TREATMENT: "Chinese Medicine Treatment",
  ACUPUNCTURE_TREATMENT: "Acupuncture Treatment",
  MASSAGE_TREATMENT: "Massage Treatment",
  REMEDIAL_MASSAGE_TREATMENT: "Remedial Massage Treatment",
  NO_RELEVANT_PRACTITIONERS_FOUND: "No relevant practitioners found",
  NO_SERVICES_LISTED: "No services listed",
  MORE_SERVICES: "more services",
  BOOK_THIS_PRACTITIONER: "Book this practitioner",
  THIS_PRACTITIONER_HAS_NOT_REGISTERED_YET:
    "This practitioner has not registered yet",
  PUBLISH_PRACTITIONER_PROFILE_WEBSITE: "Publish practitioner profile website",
  VIEW_PRACTITIONER_PROFILE_WEBSITE: "View practitioner profile website",
  NO_WORKING_CLINIC: "No working clinic",
  AND_X_MORE_CLINIC: "and {{X}} more clinic(s)",
  CHOOSE_CLINIC: "Choose Clinic",
  CHOOSE_CLINIC_DESCRIPTION: "Please choose the clinic you wish to attend",
  CHOOSE_SERVICE: "Choose Service",
  CHOOSE_SERVICE_DESCRIPTION: "Choose the services you want to book the appointment",
  CHOOSE_SERVICE_DESCRIPTION_VISIT: "Choose the services you want to book in this visit",
  PICK_APPOINTMENT_DATE: "Pick Appointment Date",
  PICK_APPOINTMENT_DATE_DESCRIPTION: "Pick your appointment date/time",
  MORNING: "Morning",
  AFTERNOON: "Afternoon",
  PATIENT_INFO_DESCRIPTION: "Please fill in the patient information",
  CONFIRM_DESCRIPTION: "Please confirm the appointment details",
  SUBMIT_APPOINTMENT: "Submit Appointment",
  PREV: "Prev",
  YOUR_APPOINTMENT_BOOKED_SUCCESSFULLY:
    "Your appointment has been created successfully",
  CREATE_BOOKING: "Create Booking",
  TOMORROW: "Tomorrow",
  TODAY: "Today",
  IS_ALREADY_BOOKED: "is already booked by someone else",
  TIME_ALREADY_BOOKED: "Time already booked",
  YOU_NEED_TO_WAIT_FOR_THE_PRACTITIONER_TO_CONFIRM:
    "Your booking will be created and added to the waiting list and will need to wait for the practitioner confirmation. You’ll receive an update once it’s approved.",
  ARE_YOU_SURE_YOU_WANT_TO_BOOK_THIS_TIME:
    "Are you sure you want to book this time?",
  BACK_TO_HOME: "Close Page",
  INVALID_DOB: "Invalid birth date",
  NOT_AVAILABLE_FOR_BOOKING: "Not available for booking",
  BOOKED_ENABLED_ONLY: "Booked Enabled Only",
  PICK_APPOINTMENT_PRACTITIONER: "Select Practitioner for",
  PICK_APPOINTMENT_PRACTITIONER_END: "",
  PICK_APPOINTMENT_PRACTITIONER_SINGLE_PATIENT: "Select Practitioner",
  RESELECT_APPOINTMENT_DATE: "Re-select Appointment Date",
  RESELECT_PRACTITIONER: "Re-select Practitioner",
  AVAILABLE_PRACTITIONERS: "Available Practitioners",
  DESELECT_CHINESE_MEDICINE_FIRST: "Please deselect Chinese Medicine first.",
  DESELECT_PRODUCTS_FIRST: "Please deselect the selected products first.",
  NUMBER_OF_PEOPLE: "Number of People",
  PERSON: "person",
  PEOPLE: "people",
  ENTER_PATIENT_INFORMATION: "Enter Patient Information",
  IS_THIS_PERSON_NEW_PATIENT: "Is this first visit to this clinic?",
  EXISTING_PATIENT: "Existing Patient",
  A_REMINDER_SMS_WILL_BE_SENT_TO_THE_U_WHEN_NEAR_THE_APPOINTMENT_DATE:
    "Tip: When the appointment time is approaching, a reminder SMS will be sent to you",
  NO_AVAILABLE_PRACTITIONERS: "No available practitioners found in this date",
  ORR: "OR",
  CONFIRM_APPOINTMENT_DESCRIPTION:
    "Please review the appointment details before confirming your booking.",
  PICK_APPOINTMENT_TIME: "Pick Appointment Time",
  PRODUCTS: "Products",
  I_AM_A_NEW_PATIENT: "I am a new patient",
  SEARCH_EXISTING_PATIENT: "Search existing patient",
  DESELECT_ALL: "Deselect",
  SERVICES_ITEM: "Service Items",
  NEW_TO_THIS_CLINIC: "This is my first visit to this clinic",
  A_REMINDER_EMAIL_WILL_BE_SENT_TO_THE_PATIENT:
    "A Confirmation Email will be sent to the patient",
  ADDITIONAL_INFO: "Additional Information",
};

const patientConsent = {
  PATIENT_CONSENT: "Patient Consent",
  CONSENT_TITLE_1: "Treatment",
  CONSENT_DESCRIPTION_1: "I understand that treatment at {{X}} may include:",
  CONSENT_ITEM_1: "Acupuncture using sterile, single-use needles ",
  CONSENT_ITEM_2: "Moxibustion, cupping, or gua sha ",
  CONSENT_ITEM_3:
    "Chinese herbal medicine (decoctions, powders, pills, or granules) ",
  CONSENT_ITEM_4:
    "Lifestyle and dietary advice based on Chinese medicine principles ",
  CONSENT_TITLE_2: "Risks and Side Effects ",
  CONSENT_DESCRIPTION_2:
    "I understand that while all reasonable care is taken, some minor side effects may occur, including: ",
  CONSENT_ITEM_5: "Slight bruising, bleeding, or soreness after needling ",
  CONSENT_ITEM_6: "Temporary dizziness or fatigue ",
  CONSENT_ITEM_7:
    "Mild digestive changes or allergic reactions from herbal medicine ",
  CONSENT_ITEM_8: "Temporary redness or marks from cupping or gua sha ",
  CONSENT_ITEM_9: "Serious adverse reactions are rare. ",
  CONSENT_TITLE_3: "Disclosure and Safety ",
  CONSENT_DESCRIPTION_3: "I have informed my practitioner of: ",
  CONSENT_ITEM_10: "Any current medical conditions or allergies ",
  CONSENT_ITEM_11: "Pregnancy status (if applicable) ",
  CONSENT_ITEM_12: "Any medication or supplements I am currently taking ",
  CONSENT_DESCRIPTION_4:
    "I understand that Chinese medicine treatment is not a substitute for emergency medical care. ",
  CONSENT_DESCRIPTION_5:
    "My personal and health information will be handled in accordance with Australian privacy laws.",
  CONSENT_TITLE_4: "Consent and Acknowledgement",
  CONSENT_ITEM_13:
    "I have read and understood the above information. I have had the opportunity to ask questions and all have been answered to my satisfaction. ",
  CONSENT_ITEM_14:
    "I voluntarily consent to receive Chinese medicine and/or acupuncture treatment from practitioners at {{X}}.",
  DRAW_YOUR_SIGNATURE: "Draw your signature",
  I_AGREE_AND_SIGN: "I agree and sign",
  SIGNATURE_UPLOADED: "Signature uploaded",
  CONSENT_SIGN_SUCCESS:
    "You have successfully signed the treatment consent form. Please proceed with your consultation process!",
};

export default {
  translation: {
    ...signUp,
    ...navigation,
    ...prescription,
    ...search,
    ...info,
    ...notification,
    ...appointment,
    ...clinicManagement,
    ...clinicHerbs,
    ...Library,
    ...packagePages,
    ...cmasaImport,
    ...camera,
    ...patientAndQuickSignUp,

    ...homePage,
    ...ourFeaturesPage,
    ...partnerPage,
    ...testimonyPage,
    ...faqPage,
    ...aboutUsPage,
    ...bookingPage,
    ...patientConsent,
    BACK: "Back",
    CLOSE: "Close",
    ONLINE_ZOOM_MEETING: "Online Zoom Meeting",
    KEY_MEMBERS: "Key Members",
    INTRODUCTION: " Brief Introduction",
    LOAD_MORE: "Load More",
    CURRENT: "Current",
    HISTORY_EVENT: "History Events",
    HISTORY_CPD: "History CPD",
    HISTORY: "In the Past",
    EXPIRED: "Expired",
    MONTH_FORMAT: "MMMM",
    EDIT: "Edit",
    FROM: "From",
    TO: "To",
    TOTAL_X: "Total {{X}} Records",
    OTHER_LANGUAGE_VERSION: "中文版",
    CLINIC: "Clinic",
    HRS: "hrs",
    VIEW: "View",
    LOADING: "Loading",
    VIEW_ALL: "View All",
    SWITCH_TEMPLATE: "Switch Template",
    TERMS_AND_CONDITIONS: "Terms and Conditions",
    PRIVACY_POLICY: "Privacy Policy",
    INITIATING: "Initiating",
    FAILED_TO_ACCESS_MICROPHONE: "Failed to access microphone",
    LISTENING: "Listening",
    TRANSCRIBING: "Transcribing",
    SPEECH_TO_TEXT: "Speech to Text",
    STOP_RECORDING: "Stop Recording",
    DISPLAYED: "Displayed",
    RECORDS: "Records",
    X_RECORDS: "{{X}} Records",
    WITH_TOTAL_X_RECORDS: "with Total {{X}} Records",
    ALL_X_RECORDS_LOADED: "All {{X}} Records Loaded",
    AI_AUTO_TRANSLATE: "AI Translate",
    ADD_TO_CLINIC_FORMULA: "Add to Clinic Formula",
    NON_PREMIUM: "Non Premium",
    NON_TOXIC: "Non Toxic",
    APPOINTMENT_HISTORY: "Appointment History",
    ADJUST_APPOINTMENT_TIME: "Adjust Appointment Time",
    ADJUST_NOW: "Adjust Now",
    I_UNDERSTAND_THE_ACTION_AND_AGREE_TO_PROCEED:
      "I understand the action and agree to proceed",
    PLEASE_NOTE_CHANGING_APPOINTMENT_DURATION_MIGHT_CAUSE_OVERBOOKING_TO_OTHER_EXISTING_APPOINTMENT:
      "Please note changing appointment duration may cause overbooking to other existing appointment",
    NEXT_WEEK: "Next Week",
    JUMP_TO_TODAY: "Jump to Today",
    APPOINTMENTS_PENDING_FOR_SCHEDULE: "Appointments Pending for Schedule",
    RELOAD: "Reload",
    CANNOT_RESCHEDULE_WITHIN_24_HOURS: "Cannot reschedule within 24 hours",
    PREV_WEEK: "Prev Week",
    PENDING_APPROVAL: "Pending Approval",
    SUBSCRIBE: "Subscribe",
    THIS_ITEM_WILL_NOT_LONGER_BE_ABLE_TO_BE_USED_IN_THIS_CLINIC:
      "This item will not longer be able to be used in this clinic",

    PLEASE_SELECT_A_VIDEO: "Please select a video",
    PLEASE_SELECT_A_COVER_IMAGE: "Please select a cover image",
    RESCHEDULE: "Reschedule",
    RESCHEDULE_APPOINTMENT: "Reschedule Appointment",
    CURRENT_APPOINTMENT_TIME: "Current appointment time",
    NEW_APPOINTMENT_TIME: "New appointment time",
    NOT_SELECTED: "Not selected",
    LINK_APPOINTMENT_TO_PATIENT_SUCCESS:
      "Appointment successfully linked to the patient",
    LINK_APPOINTMENT_TO_PATIENT: "Link appointment to patient",
    ACCEPT_APPOINTMENT: "Accept appointment",
    PROCEED_TO_PATIENT_INFO: "Proceed to patient info",
    CONFIRM_RESCHEDULE: "Confirm reschedule",
    APPOINTMENT_DATE: "Appointment date",
    PENDING_APPOINTMENT: "Pending appointment",
    PENDING_APPOINTMENTS: "Pending appointments",
    PENDING_SCHEDULE: "Pending schedule",
    LINK_TO_PATIENT: "Link to patient",
    LINK_TO_ANOTHER_PATIENT: "Link to another patient",
    LINK_ANOTHER_PATIENT_FROM_CLINIC_TO_THIS_APPOINTMENT:
      "Link another patient from your clinic to this appointment",
    THIS_PACKAGE_IS_ONLY_FOR_YOUR_CLINIC_PLZ_CREATE_ONE:
      "This package is only for your clinic, please create one",
    CLEAR: "Clear",
    YOUR_WORKING_CLINICS: "Your working clinics",
    ALL: "All",
    SEARCH_PACKAGE: "Search package",
    SEARCH_TREATMENT: "Search treatment",
    X_APPOINTMENTS_PENDING: "{{X}} appointments pending",
    X_MODALITIES_INCLUDES: "{{X}} modalities included",
    ARE_U_SURE_TO_ACCEPT_THIS_APPOINTMENT_SCHEDULE:
      "Are you sure you want to accept this appointment schedule?",
    OVERBOOKING_ACCEPTED: "Overbooking accepted",
    RESCHEDULE_SUCCESS: "Reschedule successful",
    AN_CONFIRMATION_SMS_WILL_SEND_TO_PATIENT_TO_CONFIRM_THE_RESCHEDULE:
      "An confirmation SMS will send to the patient to confirm the reschedule",
    CONTINUE: "Continue",
    VIEW_THIS_DATE_SCHEDULE: "View this date’s schedule",
    PLS_NOTE_THIS_CLINIC_INFO_WILL_BE_SUBMITTED_FOR_APPROVAL:
      "Please note this clinic information will be submitted for approval",
    YOU_WILL_BE_NOTIFIED_WHEN_APPROVAL_IS_DONE:
      "You will be notified when approval is completed",
    SUBMIT_CONFIRM: "Submit confirmation",
    PLEASE_FILL_IN_ALL_REQUIRED_FIELDS: "Please fill in all required fields",
    CLINIC_CREATE_REQUEST_SENT: "Clinic creation request sent",
    UPDATE_CONFIRM: "Update confirmation",
    ARE_YOU_SURE_TO_UPDATE_YOUR_CLINIC_INFO:
      "Are you sure you want to update your clinic information?",
    CLINIC_UPDATED: "Clinic information updated",
    CLOSED_CLINIC_SUCCESS: "Clinic closed successfully",
    PROTECTED_PAGE: "Protected Page",
    PROTECTED_PAGE_WARNING: "You need proper access to view this page.",
    U_NEED_TO_BELONG_TO_A_CLINIC_IN_ORDER_TO_USE_THIS_SERVICE:
      "You need to belong to a clinic in order to use this service.",
    ACCEPT_INVITE: "Accept Invite",
    ARE_YOU_SURE_TO_ACCEPT_INVITE:
      "Are you sure you want to accept this invite?",
    REJECT_INVITE: "Reject Invite",
    ARE_YOU_SURE_TO_REJECT_INVITE:
      "Are you sure you want to reject this invite?",
    RESPONSE_SUCCESS: "Response successful",
    JOIN_REQUEST_SENT: "Join request sent",
    REQUEST_ACCEPTED: "Request accepted",
    INVITATION_SENT: "Invitation sent",
    NO_PACKAGES: "No packages",
    X_PRACTITIONERS_ARE_NOW_INACTIVE: "{{x}} practitioners are now inactive",
    ACTIVE_CONFIRM: "Active Confirm",
    ACTIVATE: "Activate",
    INACTIVE_CONFIRM: "Inactive Confirm",
    ARE_YOU_SURE_TO_INACTIVE: "Are you sure you want to set as inactive?",
    INACTIVE_PRACTITIONERS_ARE_NOT_ALLOWED_TO_BE_BOOKED_BY_PATIENT:
      "Inactive practitioners cannot be booked by patients",
    REJECTED: "Rejected",
    RESUBMIT: "Resubmit",
    DELETE_APPLICATION: "Delete Application",
    ARE_YOU_SURE_TO_DELETE_THIS_APPLICATION:
      "Are you sure you want to delete this application",
    REBUILD_CLINIC: "Resubmit Clinic",
    DELETE_APPLICATION_SUCCESS: "Application deleted successfully",
    SEARCH_CLINIC_BY_NAME: "Search clinic by name",
    OTHER_PRACTITIONERS_ARE_NO_VISIBLE: "Other practitioners are not visible",
    DECLINE_JOIN_INVITATION_CONFIRM: "Decline join invitation confirm",
    ARE_YOU_SURE_TO_CANCEL_QUIT_FROM_CLINIC:
      "Are you sure you want to cancel quitting from the clinic?",
    SECTION_UNPUBLISHED: "Section Unpublished",
    SECTION_PUBLISHED: "Section Published",
    REFRESH: "Refresh",
    CHANGE_THIS_BOOKING_DURATION: "Change this booking duration",
    ARE_YOU_SURE_TO_CHANGE_THIS_APPOINTMENT_DURATION_FOR_X:
      "Are you sure you want to change this appointment duration for {{x}}?",
    BOOKING_DURATION_ADJUST_SUCCESS: "Booking duration adjusted successfully",
    NO_PENDING_APPOINTMENTS: "No pending appointments",
    ASSIGN_OWNERSHIP: "Assign Ownership",
    ARE_YOU_SURE_TO_ASSIGN_OWNERSHIP_TO:
      "Are you sure you want to assign ownership to",
    YOU_WILL_BE_LOST_ALL_OWNER_PERMISSIONS_IN_THIS_CLINIC:
      "You will lose all owner permissions in this clinic",
    UNLOCK_WITH_VIP: "Unlock with VIP",
    PAY_SUCCESSFUL: "Payment successful",
    OWNER_CHANGED: "Ownership changed",
    VIEW_PATIENT_INFO: "View Patient Info",
    CLINIC_QR_CODE: "Clinic QR Code",
    DOWNLOAD: "Download",
    WRONG_VERIFY_CODE: "The verification code is incorrect.",
    SMS_SEND_TOO_FREQUENT_WAIT_3_MIN_RETRY:
      "SMS sent too frequently. Please wait 3 minutes before retrying.",
    CLINICS_WILL_BE_CREATED:
      "The selected clinic(s) will be created along with your account.",
    SELECT_PRACTITIONER: "Select Practitioner",
    PLEASE_SUBSCRIBE_PACKAGE_FOR_CLINIC:
      "Please subscribe a package for this clinic.",
    CREATE_CLINICS: "Create Clinic",
    UPDATE: "Update",
    SELECT_YOUR_SPECIALTY: "Please select your specialty",
    SELECT_PATIENT_IDENTITY_FOR_APPOINTMENT:
      "We found the following patient records via your phone number. Please select the identity you would like to use for this appointment.",
    SELECT_PATIENT_IDENTITY_FOR_VISIT:
      "We found the following patient records via your phone number. Please select the identity you would like to use for this visit.",
    THIS_IS_ME: "This is me",
    CREATE_NEW_PATIENT: "Create New Patient",
    NEW_PATIENT: "New Patient",
    I_DONT_HAVE_BOOKING: "I don't have a booking",
    ENTER_YOUR_BOOKING_CODE_TO_CONTINUE:
      "Please enter the booking code you received via SMS to continue.",
    IF_U_DONT_HAVE_BOOKING_CODE:
      "If you don't have a booking code, please click button below",
    DONE: "Done",
    INVALID_CODE_PLZ_CHECK_AGAIN: "Invalid booking code.",
    PRACTITIONER_NOT_AVAILABLE_FOR_BOOKING:
      "The practitioner is not available for booking.",
    SELECT_SERVICES: "Select Services",
    RESET: "Reset",
    UNIT_NO_SHOP_NO: "Unit No./Shop No.",
    STREET_NO: "Street No.",
    STREET_NAME: "Street Name",
    CLINIC_NAME_IS_REQUIRED: "Clinic name is required",
    CLINIC_CREATED: "Clinic created",
    TYPE_TO_SEARCH: "Type to search",
    STREET_TYPE: "Street Type",
    PRESS_TO_EDIT: "Press to edit",
    PREFER_NOT_TO_SAY: "Prefer not to say",
    LOGIN: "Login",
    NO_PRODUCTS_AVAILABLE_FOR_THIS_PRACTITIONER:
      "No service products available for this practitioner",

    DEEP_TISSUE_MASSAGE: "Deep Tissue Massage",
    SPORTS_MASSAGE: "Sports Massage",
    DRY_NEEDLING: "Dry Needling",
    CUPPING: "Cupping",
    PREGNANCY_MASSAGE: "Pregnancy Massage",
    MYOTHERAPY: "Myotherapy",
    ASSISTED_STRETCHING: "Assisted Stretching",
    TRIGGER_PT_THERAPY: "Trigger Point Therapy",
    MYOFASCIAL_RELEASE: "Myofascial Release",
    JOINT_MOBILISATION: "Joint Mobilisation",
    PHYSIO: "Physiotherapy",
    CHIRO: "Chiropractic",
    BEAUTY: "Beauty",
    COSMETIC_MEDICINE: "Cosmetic Medicine",

    INVALID_PHONE_FORMAT_SMS_WARNING: "Current number may affect SMS reception. Please use 04XXXXXXXX format to ensure SMS delivery.",
    DATE_CANNOT_BE_IN_FUTURE: "Date cannot be in the future",
    INVALID_DATE: "Invalid date",
    SAVE_APPOINTMENT_INFO_LOCALLY: "Save Appoint. Details to Device",

    FOLLOW_US_ON_FACEBOOK: "Follow us on Facebook",
    DO_YOU_HAVE_BOOKING_CODE: "Do you have a booking code?",
    BOOKING_CODE_HELP_TEXT: "If you already have an appointment, continue with your booking code. Otherwise, we can register this visit for you.",
    YES_I_HAVE_BOOKING_CODE: "I have a booking code",
    NO_I_DONT_HAVE_BOOKING_CODE: "I don't have a booking code",
    ENTER_CODE_TO_CHECK_IN: "Enter your booking code to check in",
    CREATE_NEW_BOOKING_INSTEAD: "Check in with a new appointment instead",
    I_M_WALKING_CUSTOMER: "I'm a walk-in customer",
    OCCUPATION: "Occupation",
  },
};
